// Advanced search actions
export const ADVANCED_SEARCH_CONFIG_REQUEST = "selector/advanced-search/ADVANCED_SEARCH_CONFIG_REQUEST";
export const ADVANCED_SEARCH_CONFIG_SUCCESS = "selector/advanced-search/ADVANCED_SEARCH_CONFIG_SUCCESS";
export const ADVANCED_SEARCH_CONFIG_FAILURE = "selector/advanced-search/ADVANCED_SEARCH_CONFIG_FAILURE";
export const ADVANCED_SEARCH_ATTRIBUTES_REQUEST = "selector/advanced-search/ADVANCED_SEARCH_ATTRIBUTES_REQUEST";
export const ADVANCED_SEARCH_ATTRIBUTES_SUCCESS = "selector/advanced-search/ADVANCED_SEARCH_ATTRIBUTES_SUCCESS";

export const ADVANCED_SEARCH_PREVIEW_REQUEST = "selector/advanced-search/ADVANCED_SEARCH_PREVIEW_REQUEST";
export const ADVANCED_SEARCH_PREVIEW_SUCCESS = "selector/advanced-search/ADVANCED_SEARCH_PREVIEW_SUCCESS";
export const ADVANCED_SEARCH_PREVIEW_FAILURE = "selector/advanced-search/ADVANCED_SEARCH_PREVIEW_FAILURE";

export const ADVANCED_SEARCH_CLEAR = "selector/advanced-search/ADVANCED_SEARCH_CLEAR";
export const ADVANCED_SEARCH_PREVIEW_CLEAR = "selector/advanced-search/ADVANCED_SEARCH_PREVIEW_CLEAR";
// noinspection JSUnusedGlobalSymbols
export const ADVANCED_SEARCH_CHANGE_PANEL_STATE = "selector/advanced-search/ADVANCED_SEARCH_CHANGE_PANEL_STATE";
export const ADVANCED_SEARCH_POPULATE = "selector/advanced-search/ADVANCED_SEARCH_POPULATE";

export const ADVANCED_SEARCH_SCOPE_OPTIONS_REQUEST = "selector/advanced-search/ADVANCED_SEARCH_SCOPE_OPTIONS_REQUEST";
export const ADVANCED_SEARCH_SCOPE_OPTIONS_SUCCESS = "selector/advanced-search/ADVANCED_SEARCH_SCOPE_OPTIONS_SUCCESS";
export const ADVANCED_SEARCH_SCOPE_OPTIONS_FAILURE = "selector/advanced-search/ADVANCED_SEARCH_SCOPE_OPTIONS_FAILURE";

// Session actions
export const AUTHENTICATION_SUCCESS = "selector/auth/AUTHENTICATION_SUCCESS";

export const LOGIN_USER_REQUEST = "selector/auth/LOGIN_USER_REQUEST";
export const LOGIN_USER_SUCCESS = "selector/auth/LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILURE = "selector/auth/LOGIN_USER_FAILURE";
export const LOGOUT_USER = "selector/auth/LOGOUT_USER";
export const LOAD_USER_CAPABILITIES_REQUEST = "selector/auth/LOAD_USER_CAPABILITIES_REQUEST";
export const LOAD_USER_CAPABILITIES_SUCCESS = "selector/auth/LOAD_USER_CAPABILITIES_SUCCESS";
export const LOAD_USER_CAPABILITIES_FAILURE = "selector/auth/LOAD_USER_CAPABILITIES_FAILURE";

export const LOAD_USER_PARAMS_SUCCESS = "selector/auth/LOAD_USER_PARAMS_SUCCESS";
export const LOAD_USER_PARAMS_FAILURE = "selector/auth/LOAD_USER_PARAMS_FAILURE";

export const UPDATE_USER_PARAMS_REQUEST = "selector/auth/UPDATE_USER_PARAMS_REQUEST";
export const UPDATE_USER_PARAMS_SUCCESS = "selector/auth/UPDATE_USER_PARAMS_SUCCESS";
export const UPDATE_USER_PARAMS_FAILURE = "selector/auth/UPDATE_USER_PARAMS_FAILURE";
export const UPDATE_TIPS_ARE_OFF = "selector/auth/UPDATE_TIPS_ARE_OFF";
export const UPDATE_SHOW_INTRO = "selector/auth/UPDATE_SHOW_INTRO";
export const SET_REFERENCE_GENOME = "selector/auth/SET_REFERENCE_GENOME";
export const UPDATE_LOCAL_USER_PREF = "selector/auth/UPDATE_LOCAL_USER_PREF";

// BLAST actions
export const LOAD_BLAST_INDEX_LIST_REQUEST = "selector/blast/LOAD_BLAST_INDEX_LIST_REQUEST";
export const LOAD_BLAST_INDEX_LIST_SUCCESS = "selector/blast/LOAD_BLAST_INDEX_LIST_SUCCESS";
export const LOAD_BLAST_INDEX_LIST_FAILURE = "selector/blast/LOAD_BLAST_INDEX_LIST_FAILURE";

export const SUBMIT_BLAST_JOB_REQUEST = "selector/blast/SUBMIT_BLAST_JOB_REQUEST";
export const SUBMIT_BLAST_JOB_SUCCESS = "selector/blast/SUBMIT_BLAST_JOB_SUCCESS";
export const SUBMIT_BLAST_JOB_FAILURE = "selector/blast/SUBMIT_BLAST_JOB_FAILURE";

export const FILE_UPLOADS_RESET = "selector/file-upload/FILE_UPLOADS_RESET";
export const FILE_UPLOAD_REQUEST = "selector/file-upload/FILE_UPLOAD_REQUEST";
export const FILE_UPLOAD_PROGRESS = "selector/file-upload/FILE_UPLOAD_PROGRESS";
export const FILE_UPLOAD_SUCCESS = "selector/file-upload/FILE_UPLOAD_SUCCESS";
export const FILE_UPLOAD_FAILURE = "selector/file-upload/FILE_UPLOAD_FAILURE";
export const FILE_UPLOAD_ABORT = "selector/file-upload/FILE_UPLOAD_ABORT";

export const FILE_VALIDATION_REQUEST = "selector/file-upload/FILE_VALIDATION_REQUEST";
export const FILE_VALIDATION_COMPLETE = "selector/file-upload/FILE_VALIDATION_COMPLETE";
export const FILE_VALIDATION_FAILED = "selector/file-upload/FILE_VALIDATION_FAILED";
export const FILE_VALIDATION_WAITING = "selector/file-upload/FILE_VALIDATION_WAITING";
export const FILE_GLOBAL_VALIDATION_FAILED = "selector/file-upload/FILE_GLOBAL_VALIDATION_FAILED";
export const FILE_VALIDATION_RESET = "selector/file-upload/FILE_VALIDATION_RESET";

export const LOAD_SEQ_IDENTIFIERS_REQUEST = "selector/blast/LOAD_SEQ_IDENTIFIERS_REQUEST";
export const LOAD_SEQ_IDENTIFIERS_SUCCESS = "selector/blast/LOAD_SEQ_IDENTIFIERS_SUCCESS";
export const LOAD_SEQ_IDENTIFIERS_FAILURE = "selector/blast/LOAD_SEQ_IDENTIFIERS_FAILURE";
export const CLEAR_SEQ_IDENTIFIERS = "selector/blast/CLEAR_SEQ_IDENTIFIERS";

export const TOGGLE_COLORING_MODE = "selector/blast/TOGGLE_COLORING_MODE";

// Comparison actions
export const SET_COMPARISON_REQUEST = "selector/comparison/SET_COMPARISON_REQUEST";
export const SET_COMPARISON_SUCCESS = "selector/comparison/SET_COMPARISON_SUCCESS";
export const SET_COMPARISON_FAILURE = "selector/comparison/SET_COMPARISON_FAILURE";
export const SHOW_MORE_THAN_TWO_SETS_WARNING = "selector/comparison/SHOW_MORE_THAN_TWO_SETS_WARNING";
export const RESET_COMPARISON = "selector/comparison/RESET_COMPARISON";
export const CREATE_GROUP_FROM_SET_COMPARISON_REQUEST = "selector/comparison/CREATE_GROUP_FROM_SET_COMPARISON_REQUEST";
export const CREATE_GROUP_FROM_SET_COMPARISON_SUCCESS = "selector/comparison/CREATE_GROUP_FROM_SET_COMPARISON_SUCCESS";
export const CREATE_GROUP_FROM_SET_COMPARISON_FAILURE = "selector/comparison/CREATE_GROUP_FROM_SET_COMPARISON_FAILURE";

export const LOAD_GROUPS_REQUEST = "selector/comparison/LOAD_GROUPS_REQUEST";
export const LOAD_GROUPS_SUCCESS = "selector/comparison/LOAD_GROUPS_SUCCESS";
export const LOAD_GROUPS_FAILURE = "selector/comparison/LOAD_GROUPS_FAILURE";

export const LOAD_VARIANT_ANALYSIS_GROUP_REQUEST = "selector/comparison/LOAD_VARIANT_ANALYSIS_GROUP_REQUEST";
export const LOAD_VARIANT_ANALYSIS_GROUP_SUCCESS = "selector/comparison/LOAD_VARIANT_ANALYSIS_GROUP_SUCCESS";
export const LOAD_VARIANT_ANALYSIS_GROUP_FAILURE = "selector/comparison/LOAD_VARIANT_ANALYSIS_GROUP_FAILURE";

export const LOAD_VARIANT_GROUPS_REQUEST = "selector/comparison/LOAD_VARIANT_GROUPS_REQUEST";
export const LOAD_VARIANT_GROUPS_SUCCESS = "selector/comparison/LOAD_VARIANT_GROUPS_SUCCESS";
export const LOAD_VARIANT_GROUPS_FAILURE = "selector/comparison/LOAD_VARIANT_GROUPS_FAILURE";

// Config actions
export const LOAD_CONFIG_REQUEST = "selector/config/LOAD_CONFIG_REQUEST";
export const LOAD_CONFIG_SUCCESS = "selector/config/LOAD_CONFIG_SUCCESS";
export const LOAD_CONFIG_FAILURE = "selector/config/LOAD_CONFIG_FAILURE";

export const LOAD_APP_INFO_REQUEST = "selector/config/LOAD_APP_INFO_REQUEST";
export const LOAD_APP_INFO_SUCCESS = "selector/config/LOAD_APP_INFO_SUCCESS";
export const LOAD_APP_INFO_FAILURE = "selector/config/LOAD_APP_INFO_FAILURE";

// DASHBOARD actions
export const LOAD_CARD_PROJECTS_REQUEST = "selector/dashboard/LOAD_CARD_PROJECTS_REQUEST";
export const LOAD_CARD_PROJECTS_SUCCESS = "selector/dashboard/LOAD_CARD_PROJECTS_SUCCESS";
export const LOAD_CARD_PROJECTS_FAILURE = "selector/dashboard/LOAD_CARD_PROJECTS_FAILURE";

export const LOAD_CARD_RECENT_ACTIVITY_REQUEST = "selector/dashboard/LOAD_CARD_RECENT_ACTIVITY_REQUEST";
export const LOAD_CARD_RECENT_ACTIVITY_SUCCESS = "selector/dashboard/LOAD_CARD_RECENT_ACTIVITY_SUCCESS";
export const LOAD_CARD_RECENT_ACTIVITY_FAILURE = "selector/dashboard/LOAD_CARD_RECENT_ACTIVITY_FAILURE";

export const LOAD_CARD_SAMPLE_TYPE_STATUSES_REQUEST = "selector/dashboard/LOAD_CARD_SAMPLE_TYPE_STATUSES_REQUEST";
export const LOAD_CARD_SAMPLE_TYPE_STATUSES_SUCCESS = "selector/dashboard/LOAD_CARD_SAMPLE_TYPE_STATUSES_SUCCESS";
export const LOAD_CARD_SAMPLE_TYPE_STATUSES_FAILURE = "selector/dashboard/LOAD_CARD_SAMPLE_TYPE_STATUSES_FAILURE";

export const LOAD_CARD_SAVED_ITEMS_LISTING_REQUEST = "selector/dashboard/LOAD_CARD_SAVED_ITEMS_LISTING_REQUEST";
export const LOAD_CARD_SAVED_ITEMS_LISTING_SUCCESS = "selector/dashboard/LOAD_CARD_SAVED_ITEMS_LISTING_SUCCESS";
export const LOAD_CARD_SAVED_ITEMS_LISTING_FAILURE = "selector/dashboard/LOAD_CARD_SAVED_ITEMS_LISTING_FAILURE";
export const LOAD_CARD_SAVED_ITEMS_DATA_REQUEST = "selector/dashboard/LOAD_CARD_SAVED_ITEMS_DATA_REQUEST";
export const LOAD_CARD_SAVED_ITEMS_DATA_SUCCESS = "selector/dashboard/LOAD_CARD_SAVED_ITEMS_DATA_SUCCESS";
export const LOAD_CARD_SAVED_ITEMS_DATA_FAILURE = "selector/dashboard/LOAD_CARD_SAVED_ITEMS_DATA_FAILURE";

export const LOAD_DASHBOARDS_REQUEST = "selector/dashboard/LOAD_DASHBOARDS_REQUEST";
export const LOAD_DASHBOARDS_SUCCESS = "selector/dashboard/LOAD_DASHBOARDS_SUCCESS";
export const LOAD_DASHBOARDS_FAILURE = "selector/dashboard/LOAD_DASHBOARDS_FAILURE";

export const SAVE_DASHBOARD_REQUEST = "selector/dashboard/SAVE_DASHBOARD_REQUEST";
export const SAVE_DASHBOARD_SUCCESS = "selector/dashboard/SAVE_DASHBOARD_SUCCESS";
export const SAVE_DASHBOARD_FAILURE = "selector/dashboard/SAVE_DASHBOARD_FAILURE";

export const SET_DASHBOARD_EDITING_MODE = "selector/dashboard/SET_DASHBOARD_EDITING_MODE";
export const SET_DASHBOARD_FULLSCREEN_MODE = "selector/dashboard/SET_DASHBOARD_FULLSCREEN_MODE";

// Content browser actions

export const LOAD_COUNTS_REQUEST = "selector/content-browser/LOAD_COUNTS_REQUEST";
export const LOAD_COUNTS_SUCCESS = "selector/content-browser/LOAD_COUNTS_SUCCESS";
export const LOAD_COUNTS_FAILURE = "selector/content-browser/LOAD_COUNTS_FAILURE";

export const LOAD_LISTING_REQUEST = "selector/content-browser/LOAD_LISTING_REQUEST";
export const LOAD_LISTING_SUCCESS = "selector/content-browser/LOAD_LISTING_SUCCESS";
export const LOAD_LISTING_FAILURE = "selector/content-browser/LOAD_LISTING_FAILURE";

export const LOAD_INFO_REQUEST = "selector/content-browser/LOAD_INFO_REQUEST";
export const LOAD_INFO_SUCCESS = "selector/content-browser/LOAD_INFO_SUCCESS";
export const LOAD_INFO_FAILURE = "selector/content-browser/LOAD_INFO_FAILURE";

export const CONTENT_BROWSER_CHANGE_SELECTION = "selector/content-browser/CHANGE_SELECTION";
export const RESET_CONTENT_BROWSER_STATE = "selector/content-browser/RESET_CONTENT_BROWSER_STATE";

// Contig Summary actions
export const LOAD_CONTIG_REQUEST = "selector/contig-summary/LOAD_CONTIG_REQUEST";
export const LOAD_CONTIG_SUCCESS = "selector/contig-summary/LOAD_CONTIG_SUCCESS";
export const LOAD_CONTIG_FAILURE = "selector/contig-summary/LOAD_CONTIG_FAILURE";

// Contig Search actions
export const CLEAR_CONTIG_SEARCH = "selector/genome-summary/CLEAR_CONTIG_SEARCH";
export const LOAD_CONTIG_SEARCH_REQUEST = "selector/genome-summary/LOAD_CONTIG_SEARCH_REQUEST";
export const LOAD_CONTIG_SEARCH_SUCCESS = "selector/genome-summary/LOAD_CONTIG_SEARCH_SUCCESS";
export const LOAD_CONTIG_SEARCH_FAILURE = "selector/genome-summary/LOAD_CONTIG_SEARCH_FAILURE";

// Data Export actions
export const BEGIN_EXPORT_CHART = "selector/data-export/BEGIN_EXPORT_CHART";
export const END_EXPORT_CHART = "selector/data-export/END_EXPORT_CHART";

export const DOWNLOAD_FILE_FAILED = "selector/data-export/DOWNLOAD_FILE_FAILED";
export const UPLOAD_FILE_FAILED = "selector/data-export/UPLOAD_FILE_FAILED";

// Dataset viewer actions
export const LOAD_DATASET_REQUEST = "selector/dataset-viewer/LOAD_DATASET_REQUEST";
export const LOAD_DATASET_SUCCESS = "selector/dataset-viewer/LOAD_DATASET_SUCCESS";
export const LOAD_DATASET_FAILURE = "selector/dataset-viewer/LOAD_DATASET_FAILURE";

export const LOAD_DEFAULT_DATASET_REQUEST = "selector/dataset-viewer/LOAD_DEFAULT_DATASET_REQUEST";
export const LOAD_DEFAULT_DATASET_SUCCESS = "selector/dataset-viewer/LOAD_DEFAULT_DATASET_SUCCESS";
export const LOAD_DEFAULT_DATASET_FAILURE = "selector/dataset-viewer/LOAD_DEFAULT_DATASET_FAILURE";

export const LOAD_DATASET_COLUMNS_MIN_MAX_VALUES_REQUEST =
  "selector/dataset-viewer/LOAD_DATASET_COLUMNS_MIN_MAX_VALUES_REQUEST";
export const LOAD_DATASET_COLUMNS_MIN_MAX_VALUES_SUCCESS =
  "selector/dataset-viewer/LOAD_DATASET_COLUMNS_MIN_MAX_VALUES_SUCCESS";
export const LOAD_DATASET_COLUMNS_MIN_MAX_VALUES_FAILURE =
  "selector/dataset-viewer/LOAD_DATASET_COLUMNS_MIN_MAX_VALUES_FAILURE";

export const SET_GROUP_PARENT = "selector/dataset-viewer/SET_GROUP_PARENT";
export const LOAD_GROUP_DATASET_REQUEST = "selector/dataset-viewer/LOAD_GROUP_DATASET_REQUEST";
export const LOAD_GROUP_DATASET_SUCCESS = "selector/dataset-viewer/LOAD_GROUP_DATASET_SUCCESS";
export const LOAD_GROUP_DATASET_FAILURE = "selector/dataset-viewer/LOAD_GROUP_DATASET_FAILURE";

export const LOAD_DATA_SERIES_REQUEST = "selector/dataset-viewer/LOAD_DATA_SERIES_REQUEST";
export const LOAD_DATA_SERIES_SUCCESS = "selector/dataset-viewer/LOAD_DATA_SERIES_SUCCESS";
export const LOAD_DATA_SERIES_FAILURE = "selector/dataset-viewer/LOAD_DATA_SERIES_FAILURE";

export const LOAD_GROUP_DATA_SERIES_REQUEST = "selector/dataset-viewer/LOAD_GROUP_DATA_SERIES_REQUEST";
export const LOAD_GROUP_DATA_SERIES_SUCCESS = "selector/dataset-viewer/LOAD_GROUP_DATA_SERIES_SUCCESS";
export const LOAD_GROUP_DATA_SERIES_FAILURE = "selector/dataset-viewer/LOAD_GROUP_DATA_SERIES_FAILURE";

export const ADD_DATA_SERIES_REQUEST = "selector/dataset-viewer/ADD_DATA_SERIES_REQUEST";
export const ADD_DATA_SERIES_SUCCESS = "selector/dataset-viewer/ADD_DATA_SERIES_SUCCESS";
export const ADD_DATA_SERIES_FAILURE = "selector/dataset-viewer/ADD_DATA_SERIES_FAILURE";

export const CLEAR_DATASET_VIEWER = "selector/dataset-viewer/CLEAR_DATA_SERIES_REQUEST";

export const SEARCH_DATA_SERIES_REQUEST = "selector/dataset-viewer/SEARCH_DATA_SERIES_REQUEST";
export const SEARCH_DATA_SERIES_SUCCESS = "selector/dataset-viewer/SEARCH_DATA_SERIES_SUCCESS";
export const SEARCH_DATA_SERIES_FAILURE = "selector/dataset-viewer/SEARCH_DATA_SERIES_FAILURE";

export const SEARCH_GROUP_DATA_SERIES_REQUEST = "selector/dataset-viewer/SEARCH_GROUP_DATA_SERIES_REQUEST";
export const SEARCH_GROUP_DATA_SERIES_SUCCESS = "selector/dataset-viewer/SEARCH_GROUP_DATA_SERIES_SUCCESS";
export const SEARCH_GROUP_DATA_SERIES_FAILURE = "selector/dataset-viewer/SEARCH_GROUP_DATA_SERIES_FAILURE";

export const LOAD_AVAILABLE_DATASETS_REQUEST = "selector/dataset-viewer/LOAD_AVAILABLE_DATASETS_REQUEST";
export const LOAD_AVAILABLE_DATASETS_SUCCESS = "selector/dataset-viewer/LOAD_AVAILABLE_DATASETS_SUCCESS";
export const LOAD_AVAILABLE_DATASETS_FAILURE = "selector/dataset-viewer/LOAD_AVAILABLE_DATASETS_FAILURE";

export const CHART_LAYOUT_STATE_CHANGED = "selector/dataset-viewer/CHART_LAYOUT_STATE_CHANGED";
export const CHART_COLOR_SETTINGS_CHANGED = "selector/dataset-viewer/CHART_COLOR_SETTINGS_CHANGED";
export const CHART_SELECTED_CONDITIONS_CHANGED = "selector/dataset-viewer/CHART_SELECTED_CONDITIONS_CHANGED";
export const CHART_FILTERED_CONDITIONS_CHANGED = "selector/dataset-viewer/CHART_FILTERED_CONDITIONS_CHANGED";
export const CHART_SELECTED_DATASERIES_CHANGED = "selector/dataset-viewer/CHART_SELECTED_DATASERIES_CHANGED";
export const SPLIT_BY_CONDITION = "selector/dataset-viewer/SPLIT_BY_CONDITION";

export const SPLIT_PANE_LAYOUT_STATE_CHANGED = "selector/dataset-viewer/SPLIT_PANE_LAYOUT_STATE_CHANGED";
export const CHART_SELECTION_CHANGED = "selector/dataset-viewer/CHART_SELECTION_CHANGED";
export const CHART_TABLE_SELECTION_CHANGED = "selector/dataset-viewer/CHART_TABLE_SELECTION_CHANGED";
export const TOGGLE_FILTER_PANEL = "selector/dataset-viewer/TOGGLE_FILTER_PANEL";
export const SET_CHART_DATA = "selector/dataset-viewer/SET_CHART_DATA";
export const TOGGLE_DISPLAY_OF_DATA_SERIES_WITHOUT_DATA =
  "selector/dataset-viewer/TOGGLE_DISPLAY_OF_DATA_SERIES_WITHOUT_DATA";
export const RECALCULATE_DATA_SERIES_COLORS = "selector/dataset-viewer/RECALCULATE_DATA_SERIES_COLORS";

// Errors module actions
export const SET_GLOBAL_ERROR = "selector/errors/SET_GLOBAL_ERROR";
export const RESET_GLOBAL_ERROR = "selector/errors/RESET_GLOBAL_ERROR";
export const LOG_APPLICATION_ERROR = "selector/errors/LOG_APPLICATION_ERROR";

// Feature search suggestion actions
export const FEATURE_SEARCH_REQUEST = "selector/feature-search/FEATURE_SEARCH_REQUEST";
export const FEATURE_SEARCH_SUCCESS = "selector/feature-search/FEATURE_SEARCH_SUCCESS";
export const FEATURE_SEARCH_FAILURE = "selector/feature-search/FEATURE_SEARCH_FAILURE";

export const FEATURE_SEARCH_SUGGESTION_SELECT = "selector/feature-search/FEATURE_SEARCH_SUGGESTION_SELECT";

// Flag actions
// TODO: remove (Used only in Saved Items)
export const DELETE_FLAG_REQUEST = "selector/flag/DELETE_FLAG_REQUEST";
export const DELETE_FLAGS_FAILURE = "selector/flag/DELETE_FLAGS_FAILURE";

export const COPY_FLAGS_REQUEST = "selector/saved-view/COPY_FLAGS_REQUEST";
export const COPY_FLAGS_SUCCESS = "selector/saved-view/COPY_FLAGS_SUCCESS";
export const COPY_FLAGS_FAILURE = "selector/saved-view/COPY_FLAGS_FAILURE";

// Coordinate List actions

export const DELETE_COORDINATE_LIST_REQUEST = "selector/nuFeature/DELETE_COORDINATE_LIST_REQUEST";
export const DELETE_COORDINATE_LIST_FAILURE = "selector/nuFeature/DELETE_COORDINATE_LIST_FAILURE";

// Gene module actions
export const LOAD_GENE_REQUEST = "selector/gene-summary/LOAD_GENE_REQUEST";
export const LOAD_GENE_SUCCESS = "selector/gene-summary/LOAD_GENE_SUCCESS";
export const LOAD_GENE_FAILURE = "selector/gene-summary/LOAD_GENE_FAILURE";

// Genome module actions
export const RESET_GENOME = "selector/genome-summary/RESET_GENOME";
export const LOAD_GENOME_REQUEST = "selector/genome-summary/LOAD_GENOME_REQUEST";
export const LOAD_GENOME_SUCCESS = "selector/genome-summary/LOAD_GENOME_SUCCESS";
export const LOAD_GENOME_FAILURE = "selector/genome-summary/LOAD_GENOME_FAILURE";

export const LOAD_GENOME_RELATED_PROJECTS_REQUEST = "selector/genome-summary/LOAD_GENOME_RELATED_PROJECTS_REQUEST";
export const LOAD_GENOME_RELATED_PROJECTS_SUCCESS = "selector/genome-summary/LOAD_GENOME_RELATED_PROJECTS_SUCCESS";
export const LOAD_GENOME_RELATED_PROJECTS_FAILURE = "selector/genome-summary/LOAD_GENOME_RELATED_PROJECTS_FAILURE";

export const LOAD_GENOME_GFF_FEATURE_STATISTICS_REQUEST =
  "selector/genome-summary/LOAD_GENOME_GFF_FEATURE_STATISTICS_REQUEST";
export const LOAD_GENOME_GFF_FEATURE_STATISTICS_SUCCESS =
  "selector/genome-summary/LOAD_GENOME_GFF_FEATURE_STATISTICS_SUCCESS";
export const LOAD_GENOME_GFF_FEATURE_STATISTICS_FAILURE =
  "selector/genome-summary/LOAD_GENOME_GFF_FEATURE_STATISTICS_FAILURE";

export const UPDATE_LAST_OPEN_PROTEIN_FEATURE_TABLE_SPEC =
  "selector/protein-summary/UPDATE_LAST_OPEN_PROTEIN_FEATURE_TABLE_SPEC";
export const UPDATE_LAST_OPEN_NUCLEOTIDE_FEATURE_TABLE_SPEC =
  "selector/genome-summary/UPDATE_LAST_OPEN_NUCLEOTIDE_FEATURE_TABLE_SPEC";

// Genome browser module actions
export const CLEAR_GENOME_BROWSER_DATA = "selector/genome-browser/CLEAR_GENOME_BROWSER";
export const RESET_GENOME_BROWSER = "selector/genome-browser/RESET_GENOME_BROWSER";

export const LOAD_GENOME_BROWSER_GENOME_REQUEST = "selector/genome-browser/LOAD_GENOME_BROWSER_GENOME_REQUEST";
export const LOAD_GENOME_BROWSER_GENOME_SUCCESS = "selector/genome-browser/LOAD_GENOME_BROWSER_GENOME_SUCCESS";
export const LOAD_GENOME_BROWSER_GENOME_FAILURE = "selector/genome-browser/LOAD_GENOME_BROWSER_GENOME_FAILURE";

export const LOAD_GENOME_BROWSER_STATS_SUCCESS = "selector/genome-browser/LOAD_GENOME_BROWSER_STATS_SUCCESS";
export const LOAD_GENOME_BROWSER_STATS_FAILURE = "selector/genome-browser/LOAD_GENOME_BROWSER_STATS_FAILURE";

export const VIEW_RANGE_CHANGED = "selector/genome-browser/VIEW_RANGE_CHANGED";
export const SET_SELECTED_RANGE = "selector/genome-browser/SET_SELECTED_RANGE";
export const CONTIG_CHANGED = "selector/genome-browser/CONTIG_CHANGED";
export const CONTIG_AND_RANGE_CHANGED = "selector/genome-browser/CONTIG_AND_RANGE_CHANGED";
export const FEATURES_TABLE_STATE_CHANGED = "selector/genome-browser/FEATURES_TABLE_STATE_CHANGED";
export const GENOME_VIEWER_LAYOUT_CHANGED = "selector/genome-browser/GENOME_VIEWER_LAYOUT_CHANGED";
export const SHOW_ALL_FEATURES_STATE_CHANGED = "selector/genome-browser/SHOW_ALL_FEATURES_STATE_CHANGED";

export const SET_TRACK_LIST = "selector/genome-browser/SET_TRACK_LIST";
export const SET_SELECTED_MUTANT_GENOME_LIST = "selector/genome-browser/SET_SELECTED_MUTANT_GENOME_LIST";
export const HIGHLIGHT_GENOME_FEATURE = "selector/genome-browser/HIGHLIGHT_GENOME_FEATURE";
export const ADD_BED_FILE = "selector/genome-browser/ADD_BED_FILE";

export const LOAD_TRACK_FEATURES_REQUEST = "selector/genome-browser/LOAD_TRACK_FEATURES_REQUEST";
export const LOAD_TRACK_FEATURES_SUCCESS = "selector/genome-browser/LOAD_TRACK_FEATURES_SUCCESS";
export const LOAD_TRACK_FEATURES_FAILURE = "selector/genome-browser/LOAD_TRACK_FEATURES_FAILURE";

export const LOAD_TRACK_EXPRESSION_VALUES_REQUEST = "selector/genome-browser/LOAD_TRACK_EXPRESSION_VALUES_REQUEST";
export const LOAD_TRACK_EXPRESSION_VALUES_SUCCESS = "selector/genome-browser/LOAD_TRACK_EXPRESSION_VALUES_SUCCESS";
export const LOAD_TRACK_EXPRESSION_VALUES_FAILURE = "selector/genome-browser/LOAD_TRACK_EXPRESSION_VALUES_FAILURE";

export const LOAD_TRACK_COMMUNITY_ANNOTATIONS_REQUEST =
  "selector/genome-browser/LOAD_TRACK_COMMUNITY_ANNOTATIONS_REQUEST";
export const LOAD_TRACK_COMMUNITY_ANNOTATIONS_SUCCESS =
  "selector/genome-browser/LOAD_TRACK_COMMUNITY_ANNOTATIONS_SUCCESS";
export const LOAD_TRACK_COMMUNITY_ANNOTATIONS_FAILURE =
  "selector/genome-browser/LOAD_TRACK_COMMUNITY_ANNOTATIONS_FAILURE";

export const LOAD_PROFILE_FEATURES_REQUEST = "selector/genome-browser/LOAD_PROFILE_FEATURES_REQUEST";
export const LOAD_PROFILE_FEATURES_SUCCESS = "selector/genome-browser/LOAD_PROFILE_FEATURES_SUCCESS";
export const LOAD_PROFILE_FEATURES_FAILURE = "selector/genome-browser/LOAD_PROFILE_FEATURES_FAILURE";

export const LOAD_NGS_COVERAGE_FEATURES_REQUEST = "selector/genome-browser/LOAD_NGS_COVERAGE_FEATURES_REQUEST";
export const LOAD_NGS_COVERAGE_FEATURES_SUCCESS = "selector/genome-browser/LOAD_NGS_COVERAGE_FEATURES_SUCCESS";
export const LOAD_NGS_COVERAGE_FEATURES_FAILURE = "selector/genome-browser/LOAD_NGS_COVERAGE_FEATURES_FAILURE";

export const LOAD_NGS_PILEUP_FEATURES_REQUEST = "selector/genome-browser/LOAD_NGS_PILEUP_FEATURES_REQUEST";
export const LOAD_NGS_PILEUP_FEATURES_SUCCESS = "selector/genome-browser/LOAD_NGS_PILEUP_FEATURES_SUCCESS";
export const LOAD_NGS_PILEUP_FEATURES_FAILURE = "selector/genome-browser/LOAD_NGS_PILEUP_FEATURES_FAILURE";

export const LOAD_TRACK_BED_FEATURES_REQUEST = "selector/genome-browser/LOAD_TRACK_BED_FEATURES_REQUEST";
export const LOAD_TRACK_BED_FEATURES_SUCCESS = "selector/genome-browser/LOAD_TRACK_BED_FEATURES_SUCCESS";
export const LOAD_TRACK_BED_FEATURES_FAILURE = "selector/genome-browser/LOAD_TRACK_BED_FEATURES_FAILURE";

export const LOAD_TRACK_COORDINATE_FEATURES_REQUEST = "selector/genome-browser/LOAD_TRACK_COORDINATE_FEATURES_REQUEST";
export const LOAD_TRACK_COORDINATE_FEATURES_SUCCESS = "selector/genome-browser/LOAD_TRACK_COORDINATE_FEATURES_SUCCESS";
export const LOAD_TRACK_COORDINATE_FEATURES_FAILURE = "selector/genome-browser/LOAD_TRACK_COORDINATE_FEATURES_FAILURE";

export const LOAD_NGS_READ_TOOLTIP_REQUEST = "selector/genome-browser/LOAD_NGS_READ_TOOLTIP_REQUEST";
export const LOAD_NGS_READ_TOOLTIP_SUCCESS = "selector/genome-browser/LOAD_NGS_READ_TOOLTIP_SUCCESS";
export const LOAD_NGS_READ_TOOLTIP_FAILURE = "selector/genome-browser/LOAD_NGS_READ_TOOLTIP_FAILURE";
export const LOAD_TRACK_VARIANTS_REQUEST = "selector/genome-browser/LOAD_TRACK_VARIANTS_REQUEST";
export const LOAD_TRACK_VARIANTS_SUCCESS = "selector/genome-browser/LOAD_TRACK_VARIANTS_SUCCESS";
export const LOAD_TRACK_VARIANTS_FAILURE = "selector/genome-browser/LOAD_TRACK_VARIANTS_FAILURE";

export const LOAD_TRACK_VCF_VARIANTS_REQUEST = "selector/genome-browser/LOAD_TRACK_VCF_VARIANTS_REQUEST";
export const LOAD_TRACK_VCF_VARIANTS_SUCCESS = "selector/genome-browser/LOAD_TRACK_VCF_VARIANTS_SUCCESS";
export const LOAD_TRACK_VCF_VARIANTS_FAILURE = "selector/genome-browser/LOAD_TRACK_VCF_VARIANTS_FAILURE";

export const SEARCH_SEQUENCED_GENOMES_REQUEST = "selector/genome-browser/SEARCH_SEQUENCED_GENOMES_REQUEST";
export const SEARCH_SEQUENCED_GENOMES_SUCCESS = "selector/genome-browser/SEARCH_SEQUENCED_GENOMES_SUCCESS";
export const SEARCH_SEQUENCED_GENOMES_FAILURE = "selector/genome-browser/SEARCH_SEQUENCED_GENOMES_FAILURE";

export const HIGHLIGHT_MUTANT_GENOME = "selector/genome-browser/HIGHLIGHT_MUTANT_GENOME";

export const SET_GB_HIGHLIGHT_COLOR_SCHEME = "selector/genome-browser/SET_GB_HIGHLIGHT_COLOR_SCHEME";
export const SET_TRACK_CUSTOMIZATION = "selector/genome-browser/SET_TRACK_CUSTOMIZATION";

export const LOAD_DATASET_FOR_TRACK_COLORING_REQUEST =
  "selector/genome-browser/LOAD_DATASET_FOR_TRACK_COLORING_REQUEST";
export const LOAD_DATASET_FOR_TRACK_COLORING_SUCCESS =
  "selector/genome-browser/LOAD_DATASET_FOR_TRACK_COLORING_SUCCESS";
export const LOAD_DATASET_FOR_TRACK_COLORING_FAILURE =
  "selector/genome-browser/LOAD_DATASET_FOR_TRACK_COLORING_FAILURE";
export const SET_ACTIVE_FEATURES_TABLE = "selector/genome-browser/SET_ACTIVE_FEATURES_TABLE";

export const LOAD_BAM_FILE_SUCCESS = "selector/genome-browser/LOAD_BAM_FILE_SUCCESS";
export const LOAD_BAM_FILE_FAILURE = "selector/genome-browser/LOAD_BAM_FILE_FAILURE";
export const BAM_VALIDATION_FAILURE = "selector/genome-browser/BAM_VALIDATION_FAILURE";
export const BED_VALIDATION_FAILURE = "selector/genome-browser/BED_VALIDATION_FAILURE";

export const LOAD_APPLICABLE_ORG_PROPERTY_TYPES_REQUEST =
  "selector/genome-browser/LOAD_APPLICABLE_ORG_PROPERTY_TYPES_REQUEST";
export const LOAD_APPLICABLE_ORG_PROPERTY_TYPES_SUCCESS =
  "selector/genome-browser/LOAD_APPLICABLE_ORG_PROPERTY_TYPES_SUCCESS";
export const LOAD_APPLICABLE_ORG_PROPERTY_TYPES_FAILURE =
  "selector/genome-browser/LOAD_APPLICABLE_ORG_PROPERTY_TYPES_FAILURE";

export const LOAD_BAM_FILE_SUMMARY_REQUEST = "selector/genome-browser/LOAD_BAM_FILE_SUMMARY_REQUEST";
export const LOAD_BAM_FILE_SUMMARY_SUCCESS = "selector/genome-browser/LOAD_BAM_FILE_SUMMARY_SUCCESS";
export const LOAD_BAM_FILE_SUMMARY_FAILURE = "selector/genome-browser/LOAD_BAM_FILE_SUMMARY_FAILURE";

export const LOAD_TRACK_PHENOTYPE_VALUES_REQUEST = "selector/genome-browser/LOAD_TRACK_PHENOTYPE_VALUES_REQUEST";
export const LOAD_TRACK_PHENOTYPE_VALUES_SUCCESS = "selector/genome-browser/LOAD_TRACK_PHENOTYPE_VALUES_SUCCESS";
export const LOAD_TRACK_PHENOTYPE_VALUES_FAILURE = "selector/genome-browser/LOAD_TRACK_PHENOTYPE_VALUES_FAILURE";

export const LOAD_BED_FILE_SUCCESS = "selector/genome-browser/LOAD_BED_FILE_SUCCESS";
export const LOAD_BED_FILE_FAILURE = "selector/genome-browser/LOAD_BED_FILE_FAILURE";

export const LOAD_COORDINATE_LIST_SUCCESS = "selector/genome-browser/LOAD_COORDINATE_LIST_SUCCESS";
export const LOAD_COORDINATE_LIST_FAILURE = "selector/genome-browser/LOAD_COORDINATE_LIST_FAILURE";

export const LOAD_COORDINATE_LISTS_REQUEST = "selector/genome-browser/LOAD_COORDINATE_LISTS_REQUEST";
export const LOAD_COORDINATE_LISTS_SUCCESS = "selector/genome-browser/LOAD_COORDINATE_LISTS_SUCCESS";
export const LOAD_COORDINATE_LISTS_FAILURE = "selector/genome-browser/LOAD_COORDINATE_LISTS_FAILURE";

export const LOAD_COORDINATE_LISTS_BY_GENOME_REQUEST =
  "selector/genome-browser/LOAD_COORDINATE_LISTS_BY_GENOME_REQUEST";
export const LOAD_COORDINATE_LISTS_BY_GENOME_SUCCESS =
  "selector/genome-browser/LOAD_COORDINATE_LISTS_BY_GENOME_SUCCESS";
export const LOAD_COORDINATE_LISTS_BY_GENOME_FAILURE =
  "selector/genome-browser/LOAD_COORDINATE_LISTS_BY_GENOME_FAILURE";

// Global search suggestion actions
export const SET_TABLE_CONTEXT = "selector/table-context/SET_TABLE_CONTEXT";
export const GLOBAL_SEARCH_SUGGESTION_SELECT = "selector/global-search/GLOBAL_SEARCH_SUGGESTION_SELECT";

// Job actions
export const LOAD_JOB_REQUEST = "selector/job/LOAD_JOB_REQUEST";
export const LOAD_JOB_SUCCESS = "selector/job/LOAD_JOB_SUCCESS";
export const LOAD_JOB_FAILURE = "selector/job/LOAD_JOB_FAILURE";

export const LOAD_JOB_RESULT_REQUEST = "selector/job/LOAD_JOB_RESULT_REQUEST";
export const LOAD_JOB_RESULT_SUCCESS = "selector/job/LOAD_JOB_RESULT_SUCCESS";
export const LOAD_JOB_RESULT_FAILURE = "selector/job/LOAD_JOB_RESULT_FAILURE";

export const JOB_SUBSCRIPTION_START = "selector/job/JOB_SUBSCRIPTION_START";
export const JOB_SUBSCRIPTION_STOP = "selector/job/JOB_SUBSCRIPTION_STOP";
export const JOB_SUBSCRIPTION_FAILURE = "selector/job/JOB_SUBSCRIPTION_FAILURE";

export const MARK_JOB_AS_READ = "selector/job/MARK_JOB_AS_READ";
export const CLEAR_JOB = "selector/job/CLEAR_JOB";
export const CLEAR_INITIAL_JOB = "selector/job/CLEAR_INITIAL_JOB";
export const RERUN_JOB = "selector/job/RERUN_JOB";

// Notification actions
export const LOAD_NOTIFICATIONS_REQUEST = "selector/notifications/LOAD_NOTIFICATIONS_REQUEST";
export const LOAD_NOTIFICATIONS_SUCCESS = "selector/notifications/LOAD_NOTIFICATIONS_SUCCESS";
export const LOAD_NOTIFICATIONS_FAILURE = "selector/notifications/LOAD_NOTIFICATIONS_FAILURE";

export const LOAD_NOTIFICATION_SUCCESS = "selector/notifications/LOAD_NOTIFICATION_SUCCESS";
export const LOAD_NOTIFICATION_FAILURE = "selector/notifications/LOAD_NOTIFICATION_FAILURE";

export const NOTIFICATION_SUBSCRIPTION_START = "selector/notifications/NOTIFICATION_SUBSCRIPTION_START";
export const NOTIFICATION_SUBSCRIPTION_STOP = "selector/notifications/NOTIFICATION_SUBSCRIPTION_STOP";
export const NOTIFICATION_SUBSCRIPTION_FAILURE = "selector/notifications/NOTIFICATION_SUBSCRIPTION_FAILURE";

export const MARK_NOTIFICATION_AS_READ_SUCCESS = "selector/notifications/MARK_NOTIFICATION_AS_READ_SUCCESS";
export const SET_NOTIFICATION_AS_READ_FAILURE = "selector/notifications/SET_NOTIFICATION_AS_READ_FAILURE";
export const MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS = "selector/notifications/MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS";

export const FILE_DOWNLOADS_SUBSCRIPTION_FAILURE = "selector/notifications/FILE_DOWNLOADS_SUBSCRIPTION_FAILURE";
export const FILE_DOWNLOADS_SUBSCRIPTION_START = "selector/notifications/FILE_DOWNLOADS_SUBSCRIPTION_START";
export const FILE_DOWNLOADS_SUBSCRIPTION_STOP = "selector/notifications/FILE_DOWNLOADS_SUBSCRIPTION_STOP";

export const ALERTS_SUBSCRIPTION_FAILURE = "selector/notifications/ALERTS_SUBSCRIPTION_FAILURE";
export const ALERTS_SUBSCRIPTION_START = "selector/notifications/ALERTS_SUBSCRIPTION_START";
export const ALERTS_SUBSCRIPTION_STOP = "selector/notifications/ALERTS_SUBSCRIPTION_STOP";
export const ALERT_DISPLAYED = "selector/notifications/ALERT_DISPLAYED";

export const MESSAGES_SUBSCRIPTION_FAILURE = "selector/notifications/MESSAGES_SUBSCRIPTION_FAILURE";
export const MESSAGES_SUBSCRIPTION_START = "selector/notifications/MESSAGES_SUBSCRIPTION_START";
export const MESSAGES_SUBSCRIPTION_STOP = "selector/notifications/MESSAGES_SUBSCRIPTION_STOP";
export const MESSAGE_DISPLAYED = "selector/notifications/MESSAGE_DISPLAYED";

export const FILE_MESSAGES_SUBSCRIPTION_FAILURE = "selector/notifications/FILE_MESSAGES_SUBSCRIPTION_FAILURE";
export const FILE_MESSAGES_SUBSCRIPTION_START = "selector/notifications/FILE_MESSAGES_SUBSCRIPTION_START";
export const FILE_MESSAGES_SUBSCRIPTION_STOP = "selector/notifications/FILE_MESSAGES_SUBSCRIPTION_STOP";
export const FILE_MESSAGE_RECEIVED = "selector/notifications/FILE_MESSAGE_RECEIVED";
export const FILE_MESSAGE_DISPLAYED = "selector/notifications/FILE_MESSAGE_DISPLAYED";

export const INDEX_STATUS_CHANGE = "selector/files/INDEX_STATUS_CHANGE";
export const FILE_SEARCH_FAILED = "selector/files/FILE_SEARCH_FAILED";

export const LOAD_PROJECT_FILES_BY_ID_REQUEST = "selector/files/LOAD_PROJECT_FILES_BY_ID_REQUEST";
export const LOAD_PROJECT_FILES_BY_ID_SUCCESS = "selector/files/LOAD_PROJECT_FILES_BY_ID_SUCCESS";
export const LOAD_PROJECT_FILES_BY_ID_FAILURE = "selector/files/LOAD_PROJECT_FILES_BY_ID_FAILURE";

// Project actions
export const LOAD_PROJECT_REQUEST = "selector/project/LOAD_PROJECT_REQUEST";
export const LOAD_PROJECT_SUCCESS = "selector/project/LOAD_PROJECT_SUCCESS";
export const LOAD_PROJECT_FAILURE = "selector/project/LOAD_PROJECT_FAILURE";

export const LOAD_PROJECT_ACTIVITY_SUCCESS = "selector/project/LOAD_PROJECT_ACTIVITY_SUCCESS";
export const LOAD_PROJECT_ACTIVITY_FAILURE = "selector/project/LOAD_PROJECT_ACTIVITY_FAILURE";
export const LOAD_PROJECT_ACTIVITIES_SUCCESS = "selector/project/LOAD_PROJECT_ACTIVITIES_SUCCESS";
export const LOAD_PROJECT_ACTIVITIES_FAILURE = "selector/project/LOAD_PROJECT_ACTIVITIES_FAILURE";
export const CLEAN_PROJECT_ACTIVITIES = "selector/project/CLEAN_PROJECT_ACTIVITIES";

export const ACTIVITY_SUBSCRIPTION_START = "selector/project/ACTIVITY_SUBSCRIPTION_START";
export const ACTIVITY_SUBSCRIPTION_STOP = "selector/project/ACTIVITY_SUBSCRIPTION_STOP";
export const ACTIVITY_SUBSCRIPTION_FAILURE = "selector/project/ACTIVITY_SUBSCRIPTION_FAILURE";

export const ACTIVITY_CREATE_COMMENT_SUCCESS = "selector/project/ACTIVITY_CREATE_COMMENT_SUCCESS";
export const ACTIVITY_CREATE_COMMENT_FAILURE = "selector/project/ACTIVITY_CREATE_COMMENT_FAILURE";

export const DELETE_PROJECT_SUCCESS = "selector/project/DELETE_PROJECT_SUCCESS";
export const DELETE_PROJECT_FAILURE = "selector/project/DELETE_PROJECT_FAILURE";

export const DELETE_ACTIVITIES_SUCCESS = "selector/project/DELETE_ACTIVITIES_SUCCESS";
export const DELETE_ACTIVITIES_FAILURE = "selector/project/DELETE_ACTIVITIES_FAILURE";

export const UPDATE_PROJECT_ROLE_SUCCESS = "selector/project/UPDATE_PROJECT_ROLE_SUCCESS";
export const UPDATE_PROJECT_ROLE_FAILURE = "selector/project/UPDATE_PROJECT_ROLE_FAILURE";

export const ADD_PROJECT_MEMBERS_SUCCESS = "selector/project/ADD_PROJECT_MEMBERS_SUCCESS";
export const ADD_PROJECT_MEMBERS_FAILURE = "selector/project/ADD_PROJECT_MEMBERS_FAILURE";

export const REMOVE_PROJECT_MEMBER_SUCCESS = "selector/project/REMOVE_PROJECT_MEMBER_SUCCESS";
export const REMOVE_PROJECT_MEMBER_FAILURE = "selector/project/REMOVE_PROJECT_MEMBER_FAILURE";

export const FETCH_ITEMS_FOR_COMMENT_ATTACHMENTS_REQUEST = "selector/project/FETCH_SAVED_ITEMS_FOR_ATTACHMENTS_REQUEST";
export const FETCH_ITEMS_FOR_COMMENT_ATTACHMENTS_SUCCESS = "selector/project/FETCH_SAVED_ITEMS_FOR_ATTACHMENTS_SUCCESS";
export const FETCH_ITEMS_FOR_COMMENT_ATTACHMENTS_FAILURE = "selector/project/FETCH_SAVED_ITEMS_FOR_ATTACHMENTS_FAILURE";

// Projects list actions
export const LOAD_PROJECTS_REQUEST = "selector/project-list/LOAD_PROJECTS_REQUEST";
export const LOAD_PROJECTS_SUCCESS = "selector/project-list/LOAD_PROJECTS_SUCCESS";
export const LOAD_PROJECTS_FAILURE = "selector/project-list/LOAD_PROJECTS_FAILURE";

export const CREATE_PROJECT_REQUEST = "selector/project-list/CREATE_PROJECT_REQUEST";
export const CREATE_PROJECT_SUCCESS = "selector/project-list/CREATE_PROJECT_SUCCESS";
export const CREATE_PROJECT_FAILURE = "selector/project-list/CREATE_PROJECT_FAILURE";

export const MODIFY_PROJECT_REQUEST = "selector/project-list/MODIFY_PROJECT_REQUEST";
export const MODIFY_PROJECT_SUCCESS = "selector/project-list/MODIFY_PROJECT_SUCCESS";

// Protein summary actions
export const LOAD_PROTEIN_REQUEST = "selector/protein-summary/LOAD_PROTEIN_REQUEST";
export const LOAD_PROTEIN_SUCCESS = "selector/protein-summary/LOAD_PROTEIN_SUCCESS";
export const LOAD_PROTEIN_FAILURE = "selector/protein-summary/LOAD_PROTEIN_FAILURE";

// Roles Admin actions
export const LOAD_ROLES_REQUEST = "selector/roles-admin/LOAD_ROLES_REQUEST";
export const LOAD_ROLES_SUCCESS = "selector/roles-admin/LOAD_ROLES_SUCCESS";
export const LOAD_ROLES_FAILURE = "selector/roles-admin/LOAD_ROLES_FAILURE";

export const UPDATE_ROLE_REQUEST = "selector/roles-admin/UPDATE_ROLE_REQUEST";
export const UPDATE_ROLE_SUCCESS = "selector/roles-admin/UPDATE_ROLE_SUCCESS";
export const UPDATE_ROLE_FAILURE = "selector/roles-admin/UPDATE_ROLE_FAILURE";

export const CREATE_ROLE_REQUEST = "selector/roles-admin/CREATE_ROLE_REQUEST";
export const CREATE_ROLE_SUCCESS = "selector/roles-admin/CREATE_ROLE_SUCCESS";
export const CREATE_ROLE_FAILURE = "selector/roles-admin/CREATE__ROLE_FAILURE";

export const LOAD_CAPABILITIES_REQUEST = "selector/roles-admin/LOAD_CAPABILITIES_REQUEST";
export const LOAD_CAPABILITIES_SUCCESS = "selector/roles-admin/LOAD_CAPABILITIES_SUCCESS";
export const LOAD_CAPABILITIES_FAILURE = "selector/roles-admin/LOAD_CAPABILITIES_FAILURE";

export const SET_LOADED_ROLE = "selector/roles-admin/SET_LOADED_ROLE";

// Sample summary actions
export const LOAD_SAMPLE_REQUEST = "selector/sample/LOAD_SAMPLE_REQUEST";
export const LOAD_SAMPLE_SUCCESS = "selector/sample/LOAD_SAMPLE_SUCCESS";
export const LOAD_SAMPLE_FAILURE = "selector/sample/LOAD_SAMPLE_FAILURE";

// Sample parent summary actions
export const LOAD_SAMPLE_PARENT_REQUEST = "selector/parent/LOAD_SAMPLE_PARENT_REQUEST";
export const LOAD_SAMPLE_PARENT_SUCCESS = "selector/parent/LOAD_SAMPLE_PARENT_SUCCESS";
export const LOAD_SAMPLE_PARENT_FAILURE = "selector/parent/LOAD_SAMPLE_PARENT_FAILURE";

export const LOAD_SAMPLE_PARENT_STATISTICS_REQUEST = "selector/parent/LOAD_SAMPLE_PARENT_STATISTICS_REQUEST";
export const LOAD_SAMPLE_PARENT_STATISTICS_SUCCESS = "selector/parent/LOAD_SAMPLE_PARENT_STATISTICS_SUCCESS";
export const LOAD_SAMPLE_PARENT_STATISTICS_FAILURE = "selector/parent/LOAD_SAMPLE_PARENT_STATISTICS_FAILURE";

export const LOAD_PARENT_ATTRIBUTE_DEFAULTS_REQUEST = "selector/parent/LOAD_PARENT_ATTRIBUTE_DEFAULTS_REQUEST";
export const LOAD_PARENT_ATTRIBUTE_DEFAULTS_SUCCESS = "selector/parent/LOAD_PARENT_ATTRIBUTE_DEFAULTS_SUCCESS";
export const LOAD_PARENT_ATTRIBUTE_DEFAULTS_FAILURE = "selector/parent/LOAD_PARENT_ATTRIBUTE_DEFAULTS_FAILURE";

// Data Editing actions
export const LOAD_DATA_EDITING_COLUMNS_REQUEST = "selector/data-editing/LOAD_DATA_EDITING_COLUMNS_REQUEST";
export const LOAD_DATA_EDITING_COLUMNS_SUCCESS = "selector/data-editing/LOAD_DATA_EDITING_COLUMNS_SUCCESS";
export const LOAD_DATA_EDITING_COLUMNS_FAILURE = "selector/data-editing/LOAD_DATA_EDITING_COLUMNS_FAILURE";

export const LOAD_DATA_EDITING_VALUES_REQUEST = "selector/data-editing/LOAD_DATA_EDITING_VALUES_REQUEST";
export const LOAD_DATA_EDITING_VALUES_SUCCESS = "selector/data-editing/LOAD_DATA_EDITING_VALUES_SUCCESS";
export const LOAD_DATA_EDITING_VALUES_FAILURE = "selector/data-editing/LOAD_DATA_EDITING_VALUES_FAILURE";

export const DATA_EDITING_VALUES_CHANGED = "selector/data-editing/DATA_EDITING_VALUES_CHANGED";
export const CLEAR_EDITING_DATA = "selector/data-editing/CLEAR_EDITING_DATA";
export const VALIDATE_CELL_EDITING_DATA_STARTED = "selector/data-editing/VALIDATE_CELL_EDITING_DATA_STARTED";
export const VALIDATE_CELL_EDITING_DATA_COMPLETED = "selector/data-editing/VALIDATE_CELL_EDITING_DATA_COMPLETED";
export const VALIDATE_FULL_EDITING_DATA_STARTED = "selector/data-editing/VALIDATE_FULL_EDITING_DATA_STARTED";
export const VALIDATE_FULL_EDITING_DATA_COMPLETED = "selector/data-editing/VALIDATE_FULL_EDITING_DATA_COMPLETED";

export const SAVE_DATA_REQUEST = "selector/data-editing/SAVE_DATA_REQUEST";
export const SAVE_DATA_SUCCESS = "selector/data-editing/SAVE_DATA_SUCCESS";

export const ADD_DATA_EDITING_COLUMNS = "selector/data-editing/ADD_DATA_EDITING_COLUMNS";

// Data Editing actions
export const LOAD_ALL_ORG_PROPERTY_TYPES_REQUEST = "selector/data-editing/LOAD_ALL_ORG_PROPERTY_TYPES_REQUEST";
export const LOAD_ALL_ORG_PROPERTY_TYPES_SUCCESS = "selector/data-editing/LOAD_ALL_ORG_PROPERTY_TYPES_SUCCESS";
export const LOAD_ALL_ORG_PROPERTY_TYPES_FAILURE = "selector/data-editing/LOAD_ALL_ORG_PROPERTY_TYPES_FAILURE";

export const LOAD_ORG_PROPERTY_TYPE_REQUEST = "selector/data-editing/LOAD_ORG_PROPERTY_TYPE_REQUEST";
export const LOAD_ORG_PROPERTY_TYPE_SUCCESS = "selector/data-editing/LOAD_ORG_PROPERTY_TYPE_SUCCESS";
export const LOAD_ORG_PROPERTY_TYPE_FAILURE = "selector/data-editing/LOAD_ORG_PROPERTY_TYPE_FAILURE";

export const SAVE_ORG_PROPERTY_TYPE_REQUEST = "selector/data-editing/SAVE_ORG_PROPERTY_TYPE_REQUEST";
export const SAVE_ORG_PROPERTY_TYPE_SUCCESS = "selector/data-editing/SAVE_ORG_PROPERTY_TYPE_SUCCESS";
export const SAVE_ORG_PROPERTY_TYPE_FAILURE = "selector/data-editing/SAVE_ORG_PROPERTY_TYPE_FAILURE";

export const DELETE_ORG_PROPERTY_TYPES_REQUEST = "selector/data-editing/DELETE_ORG_PROPERTY_TYPES_REQUEST";
export const DELETE_ORG_PROPERTY_TYPES_SUCCESS = "selector/data-editing/DELETE_ORG_PROPERTY_TYPES_SUCCESS";
export const DELETE_ORG_PROPERTY_TYPES_FAILURE = "selector/data-editing/DELETE_ORG_PROPERTY_TYPES_FAILURE";

export const SELECT_ORG_PROPERTY_TYPE = "selector/data-editing/SELECT_ORG_PROPERTY_TYPE";
export const STORE_ORG_PROPERTY_METADATA = "selector/data-editing/STORE_ORG_PROPERTY_METADATA";

export const CLEAR_TENTATIVE_ORG_PROPERTY_TYPES = "selector/data-editing/CLEAR_TENTATIVE_ORG_PROPERTY_TYPES";

// Sample Registration/Editing actions
export const LOAD_SAMPLE_EDITING_DATA_REQUEST = "selector/sample-editing/LOAD_SAMPLE_EDITING_DATA_REQUEST";
export const LOAD_SAMPLE_EDITING_DATA_SUCCESS = "selector/sample-editing/LOAD_SAMPLE_EDITING_DATA_SUCCESS";
export const LOAD_SAMPLE_EDITING_DATA_FAILURE = "selector/sample-editing/LOAD_SAMPLE_EDITING_DATA_FAILURE";

export const SAVE_SAMPLES_REQUEST = "selector/sample-editing/SAVE_SAMPLES_REQUEST";
export const SAVE_SAMPLES_SUCCESS = "selector/sample-editing/SAVE_SAMPLES_SUCCESS";

export const UPDATE_SAMPLE_EDITING_STATE = "selector/sample-editing/UPDATE_SAMPLE_EDITING_STATE";
export const CLEAR_SAMPLE_EDITING_STATE = "selector/sample-editing/CLEAR_SAMPLE_EDITING_STATE";
export const SET_SAMPLE_GRID_CHANGES = "selector/sample-editing/SET_SAMPLE_GRID_CHANGES";

export const VALIDATE_SAMPLE_GRID_DATA_REQUEST = "selector/sample-editing/VALIDATE_SAMPLE_GRID_DATA_REQUEST";
export const VALIDATE_SAMPLE_GRID_DATA_COMPLETE = "selector/sample-editing/VALIDATE_SAMPLE_GRID_DATA_COMPLETE";

export const REGISTRATION_ADD_SAMPLES = "selector/sample-editing/REGISTRATION_ADD_SAMPLES";
export const REGISTRATION_REMOVE_SAMPLES = "selector/sample-editing/REGISTRATION_REMOVE_SAMPLES";
export const REMOVE_SAMPLE_GRID_ROW = "selector/sample-editing/REMOVE_SAMPLE_GRID_ROW";

export const SEARCH_GENOMES_FOR_SAMPLES_REQUEST = "selector/sample-editing/SEARCH_GENOMES_FOR_SAMPLES_REQUEST";
export const SEARCH_GENOMES_FOR_SAMPLES_SUCCESS = "selector/sample-editing/SEARCH_GENOMES_FOR_SAMPLES_SUCCESS";
export const SEARCH_GENOMES_FOR_SAMPLES_FAILURE = "selector/sample-editing/SEARCH_GENOMES_FOR_SAMPLES_FAILURE";

export const RESET_SAMPLE_GRID = "selector/sample-editing/RESET_SAMPLE_GRID";

export const LOAD_SAMPLE_STATUSES_BY_SET_REQUEST = "selector/sample/LOAD_SAMPLE_STATUSES_BY_SET_REQUEST";
export const LOAD_SAMPLE_STATUSES_BY_SET_SUCCESS = "selector/sample/LOAD_SAMPLE_STATUSES_BY_SET_SUCCESS";
export const LOAD_SAMPLE_STATUSES_BY_SET_FAILURE = "selector/sample/LOAD_SAMPLE_STATUSES_BY_SET_FAILURE";

export const SET_SAMPLE_LOCKING_REQUEST = "selector/sample-editing/SET_SAMPLE_LOCKING_REQUEST";
export const SET_SAMPLE_LOCKING_SUCCESS = "selector/sample-editing/SET_SAMPLE_LOCKING_SUCCESS";
export const SET_SAMPLE_LOCKING_FAILURE = "selector/sample-editing/SET_SAMPLE_LOCKING_FAILURE";

// Sample Types actions

export const LOAD_SAMPLE_TYPES_REQUEST = "selector/sample/LOAD_SAMPLE_TYPES_REQUEST";
export const LOAD_SAMPLE_TYPES_SUCCESS = "selector/sample/LOAD_SAMPLE_TYPES_SUCCESS";
export const LOAD_SAMPLE_TYPES_FAILURE = "selector/sample/LOAD_SAMPLE_TYPES_FAILURE";

// Saved Group actions

export const LOAD_GROUP_REQUEST = "selector/saved-group/LOAD_GROUP_REQUEST";
export const LOAD_GROUP_SUCCESS = "selector/saved-group/LOAD_GROUP_SUCCESS";
export const LOAD_GROUP_FAILURE = "selector/saved-group/LOAD_GROUP_FAILURE";

export const SET_VISIBLE_MUTANT_GENOMES = "selector/saved-group/SET_VISIBLE_MUTANT_GENOMES";

export const CREATE_GROUP_REQUEST = "selector/saved-group/CREATE_GROUP_REQUEST";
export const CREATE_GROUP_SUCCESS = "selector/saved-group/CREATE_GROUP_SUCCESS";
export const CREATE_GROUP_FAILURE = "selector/saved-group/CREATE_GROUP_FAILURE";

export const COPY_GROUPS_REQUEST = "selector/saved-group/COPY_GROUPS_REQUEST";
export const COPY_GROUPS_SUCCESS = "selector/saved-group/COPY_GROUPS_SUCCESS";
export const COPY_GROUPS_FAILURE = "selector/saved-group/COPY_GROUPS_FAILURE";

export const DELETE_GROUPS_FAILURE = "selector/saved-group/DELETE_GROUPS_FAILURE";
export const VIEW_UNION_GROUPS_FAILURE = "selector/saved-group/VIEW_UNION_GROUPS_FAILURE";
export const CREATE_TEMP_GROUP_FAILURE = "selector/saved-group/CREATE_TEMP_GROUP_FAILURE";

// Saved items actions
export const LOAD_SAVED_ITEMS_LISTING_REQUEST = "selector/saved-items/LOAD_SAVED_ITEMS_LISTING_REQUEST";
export const LOAD_SAVED_ITEMS_LISTING_SUCCESS = "selector/saved-items/LOAD_SAVED_ITEMS_LISTING_SUCCESS";
export const LOAD_SAVED_ITEMS_LISTING_FAILURE = "selector/saved-items/LOAD_SAVED_ITEMS_LISTING_FAILURE";
export const LOAD_SAVED_ITEMS_REQUEST = "selector/saved-items/LOAD_SAVED_ITEMS_REQUEST";
export const LOAD_SAVED_ITEMS_SUCCESS = "selector/saved-items/LOAD_SAVED_ITEMS_SUCCESS";
export const LOAD_SAVED_ITEMS_FAILURE = "selector/saved-items/LOAD_SAVED_ITEMS_FAILURE";

export const SELECT_ITEMS = "selector/saved-items/SELECT_ITEMS";

export const DELETE_SAVED_ITEM_SUCCESS = "selector/saved-items/DELETE_SAVED_ITEM_SUCCESS";

export const UPDATE_SAVED_ITEM_REQUEST = "selector/saved-items/UPDATE_SAVED_ITEM_REQUEST";
export const UPDATE_SAVED_ITEM_SUCCESS = "selector/saved-items/UPDATE_SAVED_ITEM_SUCCESS";
export const UPDATE_SAVED_ITEM_FAILURE = "selector/saved-items/UPDATE_SAVED_ITEM_FAILURE";

export const DELETE_PARENTS_FAILURE = "selector/parent/DELETE_PARENTS_FAILURE";

export const SAVE_PARENT_REQUEST = "selector/parent/SAVE_PARENT_REQUEST";
export const SAVE_PARENT_SUCCESS = "selector/parent/SAVE_PARENT_SUCCESS";
export const SAVE_PARENT_FAILURE = "selector/parent/SAVE_PARENT_FAILURE";

export const SET_ACTIVE_SAVED_ITEMS_LISTING = "selector/saved-items/SET_ACTIVE_SAVED_ITEMS_LISTING";
export const SET_ACTIVE_SAVED_ITEMS_FILTER_TERMS = "selector/saved-items/SET_ACTIVE_SAVED_ITEMS_FILTER_TERMS";

// Saved View actions

export const CLEAR_SAVED_VIEW = "selector/saved-view/CLEAR_SAVED_VIEW";
export const LOAD_VIEW_REQUEST = "selector/saved-view/LOAD_VIEW_REQUEST";
export const LOAD_VIEW_SUCCESS = "selector/saved-view/LOAD_VIEW_SUCCESS";
export const LOAD_VIEW_FAILURE = "selector/saved-view/LOAD_VIEW_FAILURE";

export const CREATE_VIEW_REQUEST = "selector/saved-view/CREATE_VIEW_REQUEST";
export const CREATE_VIEW_SUCCESS = "selector/saved-view/CREATE_VIEW_SUCCESS";
export const CREATE_VIEW_FAILURE = "selector/saved-view/CREATE_VIEW_FAILURE";

export const DELETE_VIEWS_FAILURE = "selector/saved-view/DELETE_VIEWS_FAILURE";

export const COPY_VIEWS_REQUEST = "selector/saved-view/COPY_VIEWS_REQUEST";
export const COPY_VIEWS_SUCCESS = "selector/saved-view/COPY_VIEWS_SUCCESS";
export const COPY_VIEWS_FAILURE = "selector/saved-view/COPY_VIEWS_FAILURE";

// Search Result  actions
export const RESET_GLOBAL_SEARCH = "selector/search-results/RESET_GLOBAL_SEARCH";
export const CREATE_SEARCH_RESULT_REQUEST = "selector/search-results/CREATE_SEARCH_RESULT_REQUEST";
export const CREATE_SEARCH_RESULT_SUCCESS = "selector/search-results/CREATE_SEARCH_RESULT_SUCCESS";
export const CREATE_SEARCH_RESULT_FAILURE = "selector/search-results/CREATE_SEARCH_RESULT_FAILURE";

export const LOAD_SEARCH_RESULT_REQUEST = "selector/search-results/LOAD_SEARCH_RESULT_REQUEST";
export const LOAD_SEARCH_RESULT_SUCCESS = "selector/search-results/LOAD_SEARCH_RESULT_SUCCESS";
export const LOAD_SEARCH_RESULT_FAILURE = "selector/search-results/LOAD_SEARCH_RESULT_FAILURE";

// Sequence summary actions
export const LOAD_SEQUENCE_REQUEST = "selector/sequence-summary/LOAD_SEQUENCE_REQUEST";
export const LOAD_SEQUENCE_SUCCESS = "selector/sequence-summary/LOAD_SEQUENCE_SUCCESS";
export const LOAD_SEQUENCE_FAILURE = "selector/sequence-summary/LOAD_SEQUENCE_FAILURE";

// Table actions
export const LOAD_TABLE_REQUEST = "selector/table-data/LOAD_TABLE_REQUEST";
export const LOAD_TABLE_SUCCESS = "selector/table-data/LOAD_TABLE_SUCCESS";
export const LOAD_TABLE_FAILURE = "selector/table-data/LOAD_TABLE_FAILURE";
export const LOAD_TABLE_COLUMNS_REQUEST = "selector/table-data/LOAD_TABLE_COLUMNS_REQUEST";
export const LOAD_TABLE_COLUMNS_SUCCESS = "selector/table-data/LOAD_TABLE_COLUMNS_SUCCESS";
export const LOAD_TABLE_COLUMNS_FAILURE = "selector/table-data/LOAD_TABLE_COLUMNS_FAILURE";
export const LOAD_ROWS_REQUEST = "selector/table-data/LOAD_ROWS_REQUEST";
export const LOAD_ROWS_SUCCESS = "selector/table-data/LOAD_ROWS_SUCCESS";
export const LOAD_ROWS_FAILURE = "selector/table-data/LOAD_ROWS_FAILURE";
export const LOAD_ROWS_IGNORE = "selector/table-data/LOAD_ROWS_IGNORE"; // if not the last request

export const COPY_GROUP_TO_CLASSIC_PORTAL_REQUEST = "selector/table-data/COPY_GROUP_TO_CLASSIC_PORTAL_REQUEST";
export const COPY_GROUP_TO_CLASSIC_PORTAL_SUCCESS = "selector/table-data/COPY_GROUP_TO_CLASSIC_PORTAL_SUCCESS";
export const COPY_GROUP_TO_CLASSIC_PORTAL_FAILURE = "selector/table-data/COPY_GROUP_TO_CLASSIC_PORTAL_FAILURE";

export const GROUP_RELATED_REQUEST = "selector/table-data/GROUP_RELATED_REQUEST";
export const GROUP_RELATED_SUCCESS = "selector/table-data/GROUP_RELATED_SUCCESS";
export const GROUP_RELATED_FAILURE = "selector/table-data/GROUP_RELATED_FAILURE";

export const FILTER_BY_TABLE_COLUMN = "selector/table-data/FILTER_BY_TABLE_COLUMN";
export const RESET_FILTER = "selector/table-data/RESET_FILTER";
export const SET_GLOBAL_FILTER = "selector/table-data/SET_GLOBAL_FILTER";

export const SET_COLUMN_LIST = "selector/table-data/SET_COLUMN_LIST";
export const TRIGGER_TABLE_REFRESH = "selector/table-data/TRIGGER_TABLE_REFRESH";
export const SYNC_COLUMN_LIST_FAILURE = "selector/table-data/SYNC_COLUMN_LIST_FAILURE";

export const SELECT_TABLE_ROW = "selector/table-data/SELECT_TABLE_ROW";
export const SELECT_TABLE_ROWS = "selector/table-data/SELECT_TABLE_ROWS";
export const SELECT_ALL_TABLE_ROWS = "selector/table-data/SELECT_ALL_TABLE_ROWS";
export const DESELECT_ALL_TABLE_ROWS = "selector/table-data/DESELECT_ALL_TABLE_ROWS";
export const SELECT_TABLE_RANGE = "selector/table-data/SELECT_TABLE_RANGE";

export const SELECT_TABLE = "selector/table-data/SELECT_TABLE";

export const LOAD_ROW_POSITION_FAILURE = "selector/table-data/LOAD_ROW_POSITION_FAILURE";
export const LOAD_GRID_COLUMN_FAILURE = "selector/table-data/LOAD_GRID_COLUMN_FAILURE";

export const DESTROY_ACTIVE_TABLE = "selector/table-data/DESTROY_ACTIVE_TABLE";
export const RESET_DATA_TABLE = "selector/table-data/RESET_DATA_TABLE";

export const FETCH_COLUMN_TEMPLATES_REQUEST = "selector/table-data/FETCH_COLUMN_TEMPLATES_REQUEST";
export const FETCH_COLUMN_TEMPLATES_SUCCESS = "selector/table-data/FETCH_COLUMN_TEMPLATES_SUCCESS";
export const FETCH_COLUMN_TEMPLATES_FAILURE = "selector/table-data/FETCH_COLUMN_TEMPLATES_FAILURE";

export const SELECT_COLUMN_TEMPLATE_REQUEST = "selector/table-data/SELECT_COLUMN_TEMPLATE_REQUEST";
export const SELECT_COLUMN_TEMPLATE_SUCCESS = "selector/table-data/SELECT_COLUMN_TEMPLATE_SUCCESS";
export const SELECT_COLUMN_TEMPLATE_FAILURE = "selector/table-data/SELECT_COLUMN_TEMPLATE_FAILURE";

export const DELETE_COLUMN_TEMPLATE_REQUEST = "selector/table-data/DELETE_COLUMN_TEMPLATE_REQUEST";
export const DELETE_COLUMN_TEMPLATE_SUCCESS = "selector/table-data/DELETE_COLUMN_TEMPLATE_SUCCESS";
export const DELETE_COLUMN_TEMPLATE_FAILURE = "selector/table-data/DELETE_COLUMN_TEMPLATE_FAILURE";

export const SAVE_COLUMN_TEMPLATE_REQUEST = "selector/table-data/SAVE_COLUMN_TEMPLATE_REQUEST";
export const SAVE_COLUMN_TEMPLATE_SUCCESS = "selector/table-data/SAVE_COLUMN_TEMPLATE_SUCCESS";
export const SAVE_COLUMN_TEMPLATE_FAILURE = "selector/table-data/SAVE_COLUMN_TEMPLATE_FAILURE";

export const UPDATE_COLUMN_TEMPLATE_REQUEST = "selector/table-data/UPDATE_COLUMN_TEMPLATE_REQUEST";
export const UPDATE_COLUMN_TEMPLATE_SUCCESS = "selector/table-data/UPDATE_COLUMN_TEMPLATE_SUCCESS";
export const UPDATE_COLUMN_TEMPLATE_FAILURE = "selector/table-data/UPDATE_COLUMN_TEMPLATE_FAILURE";

export const UPDATE_TABLE_GUIDANCE_STATE = "selector/table-data/UPDATE_TABLE_GUIDANCE_STATE";
export const SET_EXPANSION_PATH = "selector/table-data/SET_EXPANSION_PATH";
export const ENSURE_ROW_VISIBLE = "selector/table-data/ENSURE_ROW_ID_VISIBLE";
export const CHANGE_TABLE_RESTRICTION = "selector/table-data/CHANGE_TABLE_RESTRICTION";
export const UPDATE_TABLE_ROW = "selector/table-data/UPDATE_TABLE_ROW";

// Tracing actions
export const PUSH_TRACE = "selector/tracing/PUSH_TRACE";

// Transcript summary actions
export const LOAD_TRANSCRIPT_REQUEST = "selector/transcript-summary/LOAD_TRANSCRIPT_REQUEST";
export const LOAD_TRANSCRIPT_SUCCESS = "selector/transcript-summary/LOAD_TRANSCRIPT_SUCCESS";
export const LOAD_TRANSCRIPT_FAILURE = "selector/transcript-summary/LOAD_TRANSCRIPT_FAILURE";

// User Group administration actions

export const LOAD_USERGROUP_COUNTS_REQUEST = "selector/user-group-admin/LOAD_USERGROUP_COUNTS_REQUEST";
export const LOAD_USERGROUP_COUNTS_SUCCESS = "selector/user-group-admin/LOAD_USERGROUP_COUNTS_SUCCESS";
export const LOAD_USERGROUP_COUNTS_FAILURE = "selector/user-group-admin/LOAD_USERGROUP_COUNTS_FAILURE";

export const LOAD_USERGROUP_LISTING_REQUEST = "selector/user-group-admin/LOAD_USERGROUP_LISTING_REQUEST";
export const LOAD_USERGROUP_LISTING_SUCCESS = "selector/user-group-admin/LOAD_USERGROUP_LISTING_SUCCESS";
export const LOAD_USERGROUP_LISTING_FAILURE = "selector/user-group-admin/LOAD_USERGROUP_LISTING_FAILURE";

export const CREATE_USERGROUP_REQUEST = "selector/user-group-admin/CREATE_USERGROUP_REQUEST";
export const CREATE_USERGROUP_SUCCESS = "selector/user-group-admin/CREATE_USERGROUP_SUCCESS";
export const CREATE_USERGROUP_FAILURE = "selector/user-group-admin/CREATE_USERGROUP_FAILURE";

export const USER_GROUP_ADMIN_CHANGE_SELECTION = "selector/user-group-admin/CHANGE_SELECTION";

export const SEARCH_GENOMES_REQUEST = "selector/user-group-admin/SEARCH_GENOMES_REQUEST";
export const SEARCH_GENOMES_SUCCESS = "selector/user-group-admin/SEARCH_GENOMES_SUCCESS";
export const SEARCH_GENOMES_FAILURE = "selector/user-group-admin/SEARCH_GENOMES_FAILURE";

export const LOAD_USER_GROUPS_REQUEST = "selector/user-group-admin/LOAD_USER_GROUPS_REQUEST";
export const LOAD_USER_GROUPS_SUCCESS = "selector/user-group-admin/LOAD_USER_GROUPS_SUCCESS";
export const LOAD_USER_GROUPS_FAILURE = "selector/user-group-admin/LOAD_USER_GROUPS_FAILURE";

export const EDIT_USER_GROUPS_ASSIGNMENTS_SUCCESS = "selector/user-group-admin/EDIT_USER_GROUPS_ASSIGNMENTS_SUCCESS";
export const EDIT_USER_GROUPS_ASSIGNMENTS_FAILURE = "selector/user-group-admin/EDIT_USER_GROUPS_ASSIGNMENTS_FAILURE";
export const EDIT_USER_GROUP_SUCCESS = "selector/user-group-admin/EDIT_USER_GROUP_SUCCESS";
export const EDIT_USER_GROUP_FAILURE = "selector/user-group-admin/EDIT_USER_GROUP_FAILURE";

export const DELETE_USER_GROUP_SUCCESS = "selector/user-group-admin/DELETE_USER_GROUP_SUCCESS";
export const DELETE_USER_GROUP_FAILURE = "selector/user-group-admin/DELETE_USER_GROUP_FAILURE";

// User list actions

// Variant summary actions
export const RESET_MUTATION = "selector/variant-summary/RESET_MUTATION";
export const LOAD_MUTATION_REQUEST = "selector/variant-summary/LOAD_MUTATION_REQUEST";
export const LOAD_MUTATION_SUCCESS = "selector/variant-summary/LOAD_MUTATION_SUCCESS";
export const LOAD_MUTATION_FAILURE = "selector/variant-summary/LOAD_MUTATION_FAILURE";

// Variant summary actions
export const LOAD_VARIANT_REQUEST = "selector/variant-summary/LOAD_VARIANT_REQUEST";
export const LOAD_VARIANT_SUCCESS = "selector/variant-summary/LOAD_VARIANT_SUCCESS";
export const LOAD_VARIANT_FAILURE = "selector/variant-summary/LOAD_VARIANT_FAILURE";

// Websocket actions
export const CONNECTED_WEBSOCKET = "selector/websocket/CONNECTED_WEBSOCKET";
export const RECONNECTED_WEBSOCKET = "selector/websocket/RECONNECTED_WEBSOCKET";
export const DISCONNECTED_WEBSOCKET = "selector/websocket/DISCONNECTED_WEBSOCKET";

// Users administration actions
export const LOAD_USERS_ADMIN_REQUEST = "selector/users-admin/LOAD_USERS_ADMIN_REQUEST";
export const LOAD_USERS_ADMIN_SUCCESS = "selector/users-admin/LOAD_USERS_ADMIN_SUCCESS";
export const LOAD_USERS_ADMIN_FAILURE = "selector/users-admin/LOAD_USERS_ADMIN_FAILURE";

// Project capabilities listing actions
export const LOAD_PROJECT_CAPABILITIES_LIST_REQUEST =
  "selector/project-capabilities-list/LOAD_PROJECT_CAPABILITIES_LIST_REQUEST";
export const LOAD_PROJECT_CAPABILITIES_LIST_SUCCESS =
  "selector/project-capabilities-list/LOAD_PROJECT_CAPABILITIES_LIST_SUCCESS";
export const LOAD_PROJECT_CAPABILITIES_LIST_FAILURE =
  "selector/project-capabilities-list/LOAD_PROJECT_CAPABILITIES_LIST_FAILURE";

// Admin Sample types listing actions
export const LOAD_ADMIN_SAMPLE_TYPES_SUCCESS = "selector/sample-admin/LOAD_ADMIN_SAMPLE_TYPES_SUCCESS";
export const LOAD_ADMIN_SAMPLE_TYPES_REQUEST = "selector/sample-admin/LOAD_ADMIN_SAMPLE_TYPES_REQUEST";
export const LOAD_ADMIN_SAMPLE_TYPES_FAILURE = "selector/sample-admin/LOAD_ADMIN_SAMPLE_TYPES_FAILURE";
export const SAMPLE_TYPE_SELECTION_CHANGE = "selector/sample-admin/SAMPLE_TYPE_SELECTION_CHANGE";
export const SAMPLE_TYPE_SELECTION_RESET = "selector/sample-admin/SAMPLE_TYPE_SELECTION_RESET";

// Admin Parent types listing actions
export const LOAD_ADMIN_PARENT_TYPES_SUCCESS = "selector/sample-admin/LOAD_ADMIN_PARENT_TYPES_SUCCESS";
export const LOAD_ADMIN_PARENT_TYPES_REQUEST = "selector/sample-admin/LOAD_ADMIN_PARENT_TYPES_REQUEST";
export const LOAD_ADMIN_PARENT_TYPES_FAILURE = "selector/sample-admin/LOAD_ADMIN_PARENT_TYPES_FAILURE";
export const PARENT_TYPE_SELECTION_CHANGE = "selector/sample-admin/PARENT_TYPE_SELECTION_CHANGE";
export const PARENT_TYPE_SELECTION_RESET = "selector/sample-admin/PARENT_TYPE_SELECTION_RESET";

// Admin Sample Statuses listing actions
export const LOAD_ADMIN_SAMPLE_STATUSES_SUCCESS = "selector/sample-admin/LOAD_ADMIN_SAMPLE_STATUSES_SUCCESS";
export const LOAD_ADMIN_SAMPLE_STATUSES_REQUEST = "selector/sample-admin/LOAD_ADMIN_SAMPLE_STATUSES_REQUEST";
export const LOAD_ADMIN_SAMPLE_STATUSES_FAILURE = "selector/sample-admin/LOAD_ADMIN_SAMPLE_STATUSES_FAILURE";

// Admin Parent Type modification
export const LOAD_PARENT_TYPE_REQUEST = "selector/sample-admin/LOAD_PARENT_TYPE_REQUEST";
export const LOAD_PARENT_TYPE_SUCCESS = "selector/sample-admin/LOAD_PARENT_TYPE_SUCCESS";
export const LOAD_PARENT_TYPE_FAILURE = "selector/sample-admin/LOAD_PARENT_TYPE_FAILURE";

// Admin Parent Type modification
export const LOAD_SAMPLE_TYPE_REQUEST = "selector/sample-admin/LOAD_SAMPLE_TYPE_REQUEST";
export const LOAD_SAMPLE_TYPE_SUCCESS = "selector/sample-admin/LOAD_SAMPLE_TYPE_SUCCESS";
export const LOAD_SAMPLE_TYPE_FAILURE = "selector/sample-admin/LOAD_SAMPLE_TYPE_FAILURE";

// Creation of new attribute
export const CONTROLLED_VOCABULARY_LIST_CHANGED = "selector/sample-admin/CONTROLLED_VOCABULARY_LIST_CHANGED";
export const CREATE_ATTRIBUTE_REQUEST = "selector/sample-admin/CREATE_ATTRIBUTE_REQUEST";
export const CREATE_ATTRIBUTE_SUCCESS = "selector/sample-admin/CREATE_ATTRIBUTE_SUCCESS";
export const CREATE_ATTRIBUTE_FAILURE = "selector/sample-admin/CREATE_ATTRIBUTE_FAILURE";

// Modify an attribute
export const MODIFY_ATTRIBUTE_REQUEST = "selector/sample-admin/MODIFY_ATTRIBUTE_REQUEST";
export const MODIFY_ATTRIBUTE_SUCCESS = "selector/sample-admin/MODIFY_ATTRIBUTE_SUCCESS";
export const MODIFY_ATTRIBUTE_FAILURE = "selector/sample-admin/MODIFY_ATTRIBUTE_FAILURE";

export const DELETE_ATTRIBUTES_REQUEST = "selector/sample-admin/DELETE_ATTRIBUTES_REQUEST";
export const DELETE_ATTRIBUTES_SUCCESS = "selector/sample-admin/DELETE_ATTRIBUTES_SUCCESS";
export const DELETE_ATTRIBUTES_FAILURE = "selector/sample-admin/DELETE_ATTRIBUTES_FAILURE";

export const DELETE_SAMPLE_TYPES_REQUEST = "selector/sample-admin/DELETE_SAMPLE_TYPES_REQUEST";
export const DELETE_SAMPLE_TYPES_SUCCESS = "selector/sample-admin/DELETE_SAMPLE_TYPES_SUCCESS";
export const DELETE_SAMPLE_TYPES_FAILURE = "selector/sample-admin/DELETE_SAMPLE_TYPES_FAILURE";

export const DELETE_PARENT_TYPES_REQUEST = "selector/sample-admin/DELETE_PARENT_TYPES_REQUEST";
export const DELETE_PARENT_TYPES_SUCCESS = "selector/sample-admin/DELETE_PARENT_TYPES_SUCCESS";
export const DELETE_PARENT_TYPES_FAILURE = "selector/sample-admin/DELETE_PARENT_TYPES_FAILURE";

export const LOAD_ATTRIBUTES_REQUEST = "selector/sample-admin/LOAD_ATTRIBUTES_REQUEST";
export const LOAD_ATTRIBUTES_SUCCESS = "selector/sample-admin/LOAD_ATTRIBUTES_SUCCESS";
export const LOAD_ATTRIBUTES_FAILURE = "selector/sample-admin/LOAD_ATTRIBUTES_FAILURE";
export const LOAD_ATTRIBUTES_CLEAR = "selector/sample-admin/LOAD_ATTRIBUTES_CLEAR";

export const LOAD_ATTRIBUTE_REQUEST = "selector/sample-admin/LOAD_ATTRIBUTE_REQUEST";
export const LOAD_ATTRIBUTE_SUCCESS = "selector/sample-admin/LOAD_ATTRIBUTE_SUCCESS";
export const LOAD_ATTRIBUTE_FAILURE = "selector/sample-admin/LOAD_ATTRIBUTE_FAILURE";

export const SAVE_ADMIN_SAMPLE_TYPE_SUCCESS = "selector/sample-admin/SAVE_ADMIN_SAMPLE_TYPE_SUCCESS";
export const SAVE_ADMIN_SAMPLE_TYPE_REQUEST = "selector/sample-admin/SAVE_ADMIN_SAMPLE_TYPE_REQUEST";
export const SAVE_ADMIN_SAMPLE_TYPE_FAILURE = "selector/sample-admin/SAVE_ADMIN_SAMPLE_TYPE_FAILURE";

export const MODIFY_ADMIN_SAMPLE_TYPE_SUCCESS = "selector/sample-admin/MODIFY_ADMIN_SAMPLE_TYPE_SUCCESS";
export const MODIFY_ADMIN_SAMPLE_TYPE_REQUEST = "selector/sample-admin/MODIFY_ADMIN_SAMPLE_TYPE_REQUEST";
export const MODIFY_ADMIN_SAMPLE_TYPE_FAILURE = "selector/sample-admin/MODIFY_ADMIN_SAMPLE_TYPE_FAILURE";

export const SAVE_ADMIN_PARENT_TYPE_SUCCESS = "selector/sample-admin/SAVE_ADMIN_PARENT_TYPE_SUCCESS";
export const SAVE_ADMIN_PARENT_TYPE_REQUEST = "selector/sample-admin/SAVE_ADMIN_PARENT_TYPE_REQUEST";
export const SAVE_ADMIN_PARENT_TYPE_FAILURE = "selector/sample-admin/SAVE_ADMIN_PARENT_TYPE_FAILURE";

export const MODIFY_ADMIN_PARENT_TYPE_SUCCESS = "selector/sample-admin/MODIFY_ADMIN_PARENT_TYPE_SUCCESS";
export const MODIFY_ADMIN_PARENT_TYPE_REQUEST = "selector/sample-admin/MODIFY_ADMIN_PARENT_TYPE_REQUEST";
export const MODIFY_ADMIN_PARENT_TYPE_FAILURE = "selector/sample-admin/MODIFY_ADMIN_PARENT_TYPE_FAILURE";

export const CREATE_USERS_ADMIN_REQUEST = "selector/users-admin/CREATE_USERS_ADMIN_REQUEST";
export const CREATE_USERS_ADMIN_SUCCESS = "selector/users-admin/CREATE_USERS_ADMIN_SUCCESS";
export const CREATE_USERS_ADMIN_FAILURE = "selector/users-admin/CREATE_USERS_ADMIN_FAILURE";
export const LOAD_POTENTIAL_LDAP_USERS_ADMIN_REQUEST = "selector/users-admin/LOAD_POTENTIAL_LDAP_USERS_ADMIN_REQUEST";
export const LOAD_POTENTIAL_LDAP_USERS_ADMIN_SUCCESS = "selector/users-admin/LOAD_POTENTIAL_LDAP_USERS_ADMIN_SUCCESS";
export const LOAD_POTENTIAL_LDAP_USERS_ADMIN_FAILURE = "selector/users-admin/LOAD_POTENTIAL_LDAP_USERS_ADMIN_FAILURE";

export const CHECK_ACCEPTABLE_NEW_USERNAME_FAILURE = "selector/users-admin/CHECK_ACCEPTABLE_NEW_USERNAME_FAILURE";
export const GET_NUMBER_OF_FREE_SEATS_SUCCESS = "selector/users-admin/GET_NUMBER_OF_FREE_SEATS_SUCCESS";
export const GET_NUMBER_OF_FREE_SEATS_FAILURE = "selector/users-admin/GET_NUMBER_OF_FREE_SEATS_FAILURE";
export const MODIFY_USER_ADMIN_REQUEST = "selector/users-admin/MODIFY_USER_ADMIN_REQUEST";
export const MODIFY_USER_ADMIN_SUCCESS = "selector/users-admin/MODIFY_USER_ADMIN_SUCCESS";
export const MODIFY_USER_ADMIN_FAILURE = "selector/users-admin/MODIFY_USER_ADMIN_FAILURE";
export const INVALIDATE_PASSWORD = "selector/users-admin/INVALIDATE_PASSWORD";

export const TRANSLATE_ANALYZER_IDS_FAILURE = "selector/table-data/TRANSLATE_ANALYZER_IDS_FAILURE";

export const LOAD_TOOLS_ADMIN_REQUEST = "selector/tools-admin/LOAD_TOOLS_ADMIN_REQUEST";
export const LOAD_TOOLS_ADMIN_SUCCESS = "selector/tools-admin/LOAD_TOOLS_ADMIN_SUCCESS";
export const LOAD_TOOLS_ADMIN_FAILURE = "selector/tools-admin/LOAD_TOOLS_ADMIN_FAILURE";

export const CHECK_HAS_INTERNET_REQUEST = "selector/tools-admin/CHECK_HAS_INTERNET_REQUEST";
export const CHECK_HAS_INTERNET_SUCCESS = "selector/tools-admin/CHECK_HAS_INTERNET_SUCCESS";
export const CHECK_HAS_INTERNET_FAILURE = "selector/tools-admin/CHECK_HAS_INTERNET_FAILURE";

export const CHECK_GENOME_NAME_REQUEST = "selector/tools-admin/CHECK_GENOME_NAME_REQUEST";
export const CHECK_GENOME_NAME_SUCCESS = "selector/tools-admin/CHECK_GENOME_NAME_SUCCESS";
export const CHECK_GENOME_NAME_FAILURE = "selector/tools-admin/CHECK_GENOME_NAME_FAILURE";

export const CHECK_GENOME_IDENTIFIER_REQUEST = "selector/tools-admin/CHECK_GENOME_IDENTIFIER_REQUEST";
export const CHECK_GENOME_IDENTIFIER_SUCCESS = "selector/tools-admin/CHECK_GENOME_IDENTIFIER_SUCCESS";
export const CHECK_GENOME_IDENTIFIER_FAILURE = "selector/tools-admin/CHECK_GENOME_IDENTIFIER_FAILURE";

export const UPDATE_NCBI_STATE = "tools/ncbi/update";
export const SET_GENOME_ASSEMBLY_OPTIONS = "tools/ncbi/SET_GENOME_ASSEMBLY_OPTIONS";

export const LOADING_NCBI_TAXONOMIES = "tools/ncbi/loading_ncbi_taxonomies";
export const LOAD_NCBI_TAXONOMIES_SUCCESS = "tools/ncbi/load_ncbi_taxonomies_success";
export const LOAD_NCBI_TAXONOMIES_FAILIURE = "tools/ncbi/load_ncbi_taxonomies_failiure";

export const LOADING_NCBI_GENOMEASSEMBLIES = "tools/ncbi/loading_ncassembliesies";
export const LOADING_NCBI_GENOMEASSEMBLIES_SUCCESS = "tools/ncbi/load_ncbi_assemblies_success";
export const LOADING_NCBI_GENOMEASSEMBLIES_FAILURE = "tools/ncbi/load_ncbi_assemblies_failiure";

export const DOWNLOADING_NCBI_GENOMELIST = "tools/ncbi/downloading_ncbi_genomelist";
export const DOWNLOAD_NCBI_GENOMELIST_SUCCESS = "tools/ncbi/download_ncbi_genomelist_success";
export const DOWNLOAD_NCBI_GENOMELIST_FAILURE = "tools/ncbi/download_ncbi_genomelist_failure";

export const LOAD_ALL_USER_GROUPS_REQUEST = "tools/ncbi/LOAD_ALL_USER_GROUPS_REQUEST";
export const LOAD_ALL_USER_GROUPS_SUCCESS = "tools/ncbi/LOAD_ALL_USER_GROUPS_SUCCESS";
export const LOAD_ALL_USER_GROUPS_FAILURE = "tools/ncbi/LOAD_ALL_USER_GROUPS_FAILURE";

export const LOAD_SYSTEM_DETAILS_REQUEST = "admin/LOAD_SYSTEM_DETAILS_REQUEST";
export const LOAD_SYSTEM_DETAILS_SUCCESS = "admin/LOAD_SYSTEM_DETAILS_SUCCESS";
export const LOAD_SYSTEM_DETAILS_FAILURE = "admin/LOAD_SYSTEM_DETAILS_FAILURE";

export const SHOW_NAVBAR_DIALOG = "navbar/SHOW_NAVBAR_DIALOG";

// Playbooks Administration
export const LOAD_ADMIN_PLAYBOOKS_REQUEST = "admin/playbook-admin/LOAD_ADMIN_PLAYBOOKS_REQUEST";
export const LOAD_ADMIN_PLAYBOOKS_SUCCESS = "admin/playbook-admin/LOAD_ADMIN_PLAYBOOKS_SUCCESS";
export const LOAD_ADMIN_PLAYBOOKS_FAILURE = "admin/playbook-admin/LOAD_ADMIN_PLAYBOOKS_FAILURE";

export const LOAD_ADMIN_PLAYBOOK_REQUEST = "selector/playbook-admin/LOAD_ADMIN_PLAYBOOK_REQUEST";
export const LOAD_ADMIN_PLAYBOOK_SUCCESS = "selector/playbook-admin/LOAD_ADMIN_PLAYBOOK_SUCCESS";
export const LOAD_ADMIN_PLAYBOOK_FAILURE = "selector/playbook-admin/LOAD_ADMIN_PLAYBOOK_FAILURE";

export const LOAD_ADMIN_PLAYBOOK_CATEGORIES_REQUEST = "admin/playbook-admin/LOAD_ADMIN_PLAYBOOK_CATEGORIES_REQUEST";
export const LOAD_ADMIN_PLAYBOOK_CATEGORIES_SUCCESS = "admin/playbook-admin/LOAD_ADMIN_PLAYBOOK_CATEGORIES_SUCCESS";
export const LOAD_ADMIN_PLAYBOOK_CATEGORIES_FAILURE = "admin/playbook-admin/LOAD_ADMIN_PLAYBOOK_CATEGORIES_FAILURE";

export const SAVE_ADMIN_PLAYBOOK_CATEGORIES_REQUEST = "admin/playbook-admin/SAVE_ADMIN_PLAYBOOK_CATEGORIES_REQUEST";
export const SAVE_ADMIN_PLAYBOOK_CATEGORIES_SUCCESS = "admin/playbook-admin/SAVE_ADMIN_PLAYBOOK_CATEGORIES_SUCCESS";
export const SAVE_ADMIN_PLAYBOOK_CATEGORIES_FAILURE = "admin/playbook-admin/SAVE_ADMIN_PLAYBOOK_CATEGORIES_FAILURE";

export const EDIT_ADMIN_PLAYBOOK_CATEGORIES_REQUEST = "admin/playbook-admin/EDIT_ADMIN_PLAYBOOK_CATEGORIES_REQUEST";
export const EDIT_ADMIN_PLAYBOOK_CATEGORIES_SUCCESS = "admin/playbook-admin/EDIT_ADMIN_PLAYBOOK_CATEGORIES_SUCCESS";
export const EDIT_ADMIN_PLAYBOOK_CATEGORIES_FAILURE = "admin/playbook-admin/EDIT_ADMIN_PLAYBOOK_CATEGORIES_FAILURE";

export const DELETE_ADMIN_PLAYBOOK_CATEGORIES_REQUEST = "admin/playbook-admin/DELETE_ADMIN_PLAYBOOK_CATEGORIES_REQUEST";
export const DELETE_ADMIN_PLAYBOOK_CATEGORIES_SUCCESS = "admin/playbook-admin/DELETE_ADMIN_PLAYBOOK_CATEGORIES_SUCCESS";
export const DELETE_ADMIN_PLAYBOOK_CATEGORIES_FAILURE = "admin/playbook-admin/DELETE_ADMIN_PLAYBOOK_CATEGORIES_FAILURE";

export const LOAD_ADMIN_NFWORKFLOW_REQUEST = "selector/playbook-admin/LOAD_ADMIN_NFWORKFLOW_REQUEST";
export const LOAD_ADMIN_NFWORKFLOW_SUCCESS = "selector/playbook-admin/LOAD_ADMIN_NFWORKFLOW_SUCCESS";
export const LOAD_ADMIN_NFWORKFLOW_FAILURE = "selector/playbook-admin/LOAD_ADMIN_NFWORKFLOW_FAILURE";

export const LOAD_ADMIN_P2WORKFLOW_REQUEST = "selector/playbook-admin/LOAD_ADMIN_P2WORKFLOW_REQUEST";
export const LOAD_ADMIN_P2WORKFLOW_SUCCESS = "selector/playbook-admin/LOAD_ADMIN_P2WORKFLOW_SUCCESS";
export const LOAD_ADMIN_P2WORKFLOW_FAILURE = "selector/playbook-admin/LOAD_ADMIN_P2WORKFLOW_FAILURE";

export const UPDATE_PLAYBOOK_CONFIG_STATE = "admin/playbook-admin/UPDATE_PLAYBOOK_CONFIG_STATE";
export const CLEAR_PLAYBOOK_CONFIG_STATE = "admin/playbook-admin/CLEAR_PLAYBOOK_CONFIG_STATE";

export const SAVE_PLAYBOOK_REQUEST = "admin/playbook-admin/SAVE_NEW_PLAYBOOKS_REQUEST";
export const SAVE_PLAYBOOK_SUCCESS = "admin/playbook-admin/SAVE_NEW_PLAYBOOKS_SUCCESS";
export const SAVE_PLAYBOOK_FAILURE = "admin/playbook-admin/SAVE_NEW_PLAYBOOKS_FAILURE";

// Playbooks Execution
export const OPEN_PLAYBOOK = "selector/playbook-execution/OPEN_PLAYBOOK";
export const LOAD_PLAYBOOK_REQUEST = "selector/playbook-execution/LOAD_PLAYBOOK_REQUEST";
export const LOAD_PLAYBOOK_SUCCESS = "selector/playbook-execution/LOAD_PLAYBOOK_SUCCESS";
export const LOAD_PLAYBOOK_FAILURE = "selector/playbook-execution/LOAD_PLAYBOOK_FAILURE";

export const LOAD_WORKFLOW_SUCCESS = "selector/playbook-execution/LOAD_WORKFLOW_SUCCESS";
export const LOAD_WORKFLOW_FAILURE = "selector/playbook-execution/LOAD_WORKFLOW_FAILURE";
export const UPDATE_PLAYBOOK_EXECUTION_STATE = "selector/playbook-execution/UPDATE_PLAYBOOK_EXECUTION_STATE";
export const RESET_PLAYBOOK_EXECUTION_STATE = "selector/playbook-execution/RESET_PLAYBOOK_EXECUTION_STATE";

export const EXECUTE_ANALYSIS_REQUEST = "selector/playbook-execution/EXECUTE_ANALYSIS_REQUEST";
export const EXECUTE_ANALYSIS_SUCCESS = "selector/playbook-execution/EXECUTE_ANALYSIS_SUCCESS";
export const EXECUTE_ANALYSIS_FAILURE = "selector/playbook-execution/EXECUTE_ANALYSIS_FAILURE";

// Nextflow Playbooks Execution
export const OPEN_NF_PLAYBOOK = "selector/nf-playbook-execution/OPEN_NF_PLAYBOOK";
export const CLOSE_NF_PLAYBOOK = "selector/nf-playbook-execution/CLOSE_NF_PLAYBOOK";
export const LOAD_NF_PLAYBOOK_REQUEST = "selector/nf-playbook-execution/LOAD_NF_PLAYBOOK_REQUEST";
export const LOAD_NF_PLAYBOOK_SUCCESS = "selector/nf-playbook-execution/LOAD_NF_PLAYBOOK_SUCCESS";
export const LOAD_NF_PLAYBOOK_FAILURE = "selector/nf-playbook-execution/LOAD_NF_PLAYBOOK_FAILURE";
export const RESET_NF_PLAYBOOK_EXECUTION_STATE = "selector/nf-playbook-execution/RESET_NF_PLAYBOOK_EXECUTION_STATE";
export const UPDATE_NF_PLAYBOOK_EXECUTION_STATE = "selector/nf-playbook-execution/UPDATE_NF_PLAYBOOK_EXECUTION_STATE";

// Playbooks Page
export const LOAD_PLAYBOOKS_REQUEST = "admin/playbooks/LOAD_PLAYBOOKS_REQUEST";
export const LOAD_PLAYBOOKS_SUCCESS = "admin/playbooks/LOAD_PLAYBOOKS_SUCCESS";
export const LOAD_PLAYBOOKS_FAILURE = "admin/playbooks/LOAD_PLAYBOOKS_FAILURE";
export const LOAD_PLAYBOOK_CATEGORY_REQUEST = "admin/playbooks/LOAD_PLAYBOOK_CATEGORY_REQUEST";
export const LOAD_PLAYBOOK_CATEGORY_SUCCESS = "admin/playbooks/LOAD_PLAYBOOK_CATEGORY_SUCCESS";
export const LOAD_PLAYBOOK_CATEGORY_FAILURE = "admin/playbooks/LOAD_PLAYBOOK_CATEGORY_FAILURE";

export const SET_PLAYBOOKS_CATEGORY = "selector/playbooks/SET_PLAYBOOKS_CATEGORY";
export const SET_USE_DEMO_DATA = "selector/execution/SET_USE_DOME_DATA";

// Files
export const CREATE_FOLDER_FAILED = "selector/collector/CREATE_FOLDER_FAILED";
export const UPDATE_INDEXING_STATUS = "selector/collector/UPDATE_INDEXING_STATUS";

export const UPLOAD_RESOURCE_REQUEST = "selector/collector/UPLOAD_RESOURCE_REQUEST";
export const UPLOAD_RESOURCE_SUCCESS = "selector/collector/UPLOAD_RESOURCE_SUCCESS";
export const UPLOAD_RESOURCE_FAILURE = "selector/collector/UPLOAD_RESOURCE_FAILURE";
export const UPLOAD_RESOURCE_PROGRESS = "selector/collector/UPLOAD_RESOURCE_PROGRESS";
export const UPLOAD_RESOURCE_REMOVE = "selector/collector/UPLOAD_RESOURCE_REMOVE";
export const UPLOAD_RESOURCE_CANCEL = "selector/collector/UPLOAD_RESOURCE_CANCEL";

export const STORE_FILES_TO_COPY = "selector/collector/STORE_FILES_TO_COPY";
export const STORE_FILES_TO_CUT = "selector/collector/STORE_FILES_TO_CUT";

export const UPDATE_PROJECT_FILE_REQUEST = "selector/file/UPDATE_PROJECT_FILE_REQUEST";
export const UPDATE_PROJECT_FILE_SUCCESS = "selector/file/UPDATE_PROJECT_FILE_SUCCESS";
export const UPDATE_PROJECT_FILE_FAILURE = "selector/file/UPDATE_PROJECT_FILE_FAILURE";

export const COPY_FILES_REQUEST = "selector/collector/COPY_FILES_REQUEST";
export const COPY_FILES_SUCCESS = "selector/collector/COPY_FILES_SUCCESS";
export const COPY_FILES_FAILURE = "selector/collector/COPY_FILES_FAILURE";

export const CUT_FILES_REQUEST = "selector/collector/CUT_FILES_REQUEST";
export const CUT_FILES_SUCCESS = "selector/collector/CUT_FILES_SUCCESS";
export const CUT_FILES_FAILURE = "selector/collector/CUT_FILES_FAILURE";

export const INDEX_BAM_FILE_REQUEST = "selector/collector/INDEX_BAM_FILE_REQUEST";
export const INDEX_BAM_FILE_SUCCESS = "selector/collector/INDEX_BAM_FILE_SUCCESS";
export const INDEX_BAM_FILE_FAILURE = "selector/collector/INDEX_BAM_FILE_FAILURE";

export const LOAD_ALL_FEATURE_TYPES_REQUEST = "selector/listing/LOAD_ALL_FEATURE_TYPES_REQUEST";
export const LOAD_ALL_FEATURE_TYPES_SUCCESS = "selector/listing/LOAD_ALL_FEATURE_TYPES_SUCCESS";
export const LOAD_ALL_FEATURE_TYPES_FAILURE = "selector/listing/LOAD_ALL_FEATURE_TYPES_FAILURE";

export const LOAD_ALL_SEQUENCE_TYPES_REQUEST = "selector/listing/LOAD_ALL_SEQUENCE_TYPES_REQUEST";
export const LOAD_ALL_SEQUENCE_TYPES_SUCCESS = "selector/listing/LOAD_ALL_SEQUENCE_TYPES_SUCCESS";
export const LOAD_ALL_SEQUENCE_TYPES_FAILURE = "selector/listing/LOAD_ALL_SEQUENCE_TYPES_FAILURE";

export const LOAD_APPROVED_WORKFLOWS_REQUEST = "selector/listing/LOAD_APPROVED_WORKFLOWS_REQUEST";
export const LOAD_APPROVED_WORKFLOWS_SUCCESS = "selector/listing/LOAD_APPROVED_WORKFLOWS_SUCCESS";
export const LOAD_APPROVED_WORKFLOWS_FAILURE = "selector/listing/LOAD_APPROVED_WORKFLOWS_FAILURE";

// Load Marker actions
export const LOAD_MARKER_REQUEST = "selector/marker-summary/LOAD_MARKER_REQUEST";
export const LOAD_MARKER_SUCCESS = "selector/marker-summary/LOAD_MARKER_SUCCESS";
export const LOAD_MARKER_FAILURE = "selector/marker-summary/LOAD_MARKER_FAILURE";

// Load NuFeature actions
export const LOAD_NUFEATURE_REQUEST = "selector/nuFeature-summary/LOAD_NUFEATURE_REQUEST";
export const LOAD_NUFEATURE_SUCCESS = "selector/nuFeature-summary/LOAD_NUFEATURE_SUCCESS";
export const LOAD_NUFEATURE_FAILURE = "selector/nuFeature-summary/LOAD_NUFEATURE_FAILURE";

// Load AaFeature actions
export const LOAD_AAFEATURE_REQUEST = "selector/aaFeature-summary/LOAD_AAFEATURE_REQUEST";
export const LOAD_AAFEATURE_SUCCESS = "selector/aaFeature-summary/LOAD_AAFEATURE_SUCCESS";
export const LOAD_AAFEATURE_FAILURE = "selector/aaFeature-summary/LOAD_AAFEATURE_FAILURE";

// Load Event actions
export const LOAD_EVENT_REQUEST = "selector/event-summary/LOAD_EVENT_REQUEST";
export const LOAD_EVENT_SUCCESS = "selector/event-summary/LOAD_EVENT_SUCCESS";
export const LOAD_EVENT_FAILURE = "selector/event-summary/LOAD_EVENT_FAILURE";

// Load Event actions
export const MODIFY_EVENT_REQUEST = "selector/event-summary/MODIFY_EVENT_REQUEST";
export const MODIFY_EVENT_SUCCESS = "selector/event-summary/MODIFY_EVENT_SUCCESS";
export const MODIFY_EVENT_FAILURE = "selector/event-summary/MODIFY_EVENT_FAILURE";

// Creation of new sequence database
export const DELETE_SEQUENCES_REQUEST = "selector/sequences/DELETE_SEQUENCES_REQUEST";
export const DELETE_SEQUENCES_SUCCESS = "selector/sequences/DELETE_SEQUENCES_SUCCESS";
export const DELETE_SEQUENCES_FAILURE = "selector/sequences/DELETE_SEQUENCES_FAILURE";
